export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
};

/** Autogenerated input type of AddDeviceToUser */
export type AddDeviceToUserInput = {
  /** Versión de la aplicación */
  appVersion?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Identificador del dispositivo (opcional) */
  deviceIdentifier?: InputMaybe<Scalars['String']['input']>;
  /** Plataforma: 'ios' o 'android' */
  platform: Scalars['String']['input'];
  /** Token del dispositivo FCM/APNS */
  token: Scalars['String']['input'];
};

/** Autogenerated return type of AddDeviceToUser. */
export type AddDeviceToUserPayload = {
  __typename?: 'AddDeviceToUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of AddPlayerToMarket */
export type AddPlayerToMarketInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  fantasyLeagueId: Scalars['ID']['input'];
  playerId: Scalars['ID']['input'];
  price: Scalars['Int']['input'];
};

/** Autogenerated return type of AddPlayerToMarket. */
export type AddPlayerToMarketPayload = {
  __typename?: 'AddPlayerToMarketPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  marketEntry?: Maybe<MarketEntry>;
};

/** Configuration served from the backend so the frontend does not hardcode it and values can change without a mobile release. */
export type AppConfig = {
  __typename?: 'AppConfig';
  /** The daily market-hours restriction window. */
  marketHours: MarketHours;
  /** Maximum length (characters) allowed for the title of a channel post's related link. */
  postMaxLinkTitleLength: Scalars['Int']['output'];
  /** Maximum number of photos a channel post can have. */
  postMaxPhotos: Scalars['Int']['output'];
  /** Maximum length (characters) allowed for a channel post's text. */
  postMaxTextLength: Scalars['Int']['output'];
};

export type AutonomousCommunity = {
  __typename?: 'AutonomousCommunity';
  flagUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Bid = {
  __typename?: 'Bid';
  amount: Scalars['Int']['output'];
  bidder?: Maybe<FantasyLeagueMember>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  marketEntry: MarketEntry;
  status: Scalars['String']['output'];
};

export type CareerEntry = {
  __typename?: 'CareerEntry';
  careerOrganization: CareerOrganization;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Optional free-text details of the entry (e.g. the category or league) */
  details?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['ID']['output'];
  role: CareerRoleEnum;
  startDate: Scalars['ISO8601Date']['output'];
};

export type CareerEntryOverlap = {
  __typename?: 'CareerEntryOverlap';
  /** Career entries that overlap the requested entry */
  careerEntries: Array<CareerEntry>;
  profile: PublicUserProfile;
};

export type CareerEntryOverlaps = {
  __typename?: 'CareerEntryOverlaps';
  careerOrganization: CareerOrganization;
  /** Number of profiles requested */
  limit: Scalars['Int']['output'];
  /** Other users and the career entries that overlap the requested entry */
  matches: Array<CareerEntryOverlap>;
  /** Current offset in pagination */
  offset: Scalars['Int']['output'];
  /** Total number of matching profiles */
  totalCount: Scalars['Int']['output'];
};

export type CareerOrganization = {
  __typename?: 'CareerOrganization';
  id: Scalars['ID']['output'];
  /** URL of the organization's image, if any */
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** False for organizations entered by users that are not in the catalogue yet */
  registered: Scalars['Boolean']['output'];
};

/** A page of the users linked to a career organization */
export type CareerOrganizationProfiles = {
  __typename?: 'CareerOrganizationProfiles';
  careerOrganization: CareerOrganization;
  /** Number of profiles requested */
  limit: Scalars['Int']['output'];
  /** Current offset in pagination */
  offset: Scalars['Int']['output'];
  profiles: Array<PublicUserProfile>;
  /** Total number of matching profiles */
  totalCount: Scalars['Int']['output'];
};

/** Which users of a career organization to list */
export const CareerOrganizationProfilesPeriodEnum = {
  /** Users with a current career entry (without end date) in the organization */
  Current: 'CURRENT',
  /** Users that were in the organization in the past and are not in it anymore */
  Past: 'PAST'
} as const;

export type CareerOrganizationProfilesPeriodEnum = typeof CareerOrganizationProfilesPeriodEnum[keyof typeof CareerOrganizationProfilesPeriodEnum];
/** A page of career organizations */
export type CareerOrganizationsPage = {
  __typename?: 'CareerOrganizationsPage';
  /** Number of organizations requested */
  limit: Scalars['Int']['output'];
  /** Current offset in pagination */
  offset: Scalars['Int']['output'];
  organizations: Array<CareerOrganization>;
  /** Total number of matching organizations */
  totalCount: Scalars['Int']['output'];
};

/** A role held by a user during a career entry */
export const CareerRoleEnum = {
  /** Coach */
  Coach: 'COACH',
  /** Executive */
  Executive: 'EXECUTIVE',
  /** Fitness coach */
  FitnessCoach: 'FITNESS_COACH',
  /** Journalist */
  Journalist: 'JOURNALIST',
  /** Kit manager */
  KitManager: 'KIT_MANAGER',
  /** Physiotherapist */
  Physiotherapist: 'PHYSIOTHERAPIST',
  /** Player */
  Player: 'PLAYER',
  /** Psychologist */
  Psychologist: 'PSYCHOLOGIST',
  /** Referee */
  Referee: 'REFEREE',
  /** Supporter */
  Supporter: 'SUPPORTER',
  /** Team delegate */
  TeamDelegate: 'TEAM_DELEGATE'
} as const;

export type CareerRoleEnum = typeof CareerRoleEnum[keyof typeof CareerRoleEnum];
export type Channel = {
  __typename?: 'Channel';
  allowComments: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  followers: Array<UserAccount>;
  followersCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** Whether posts of this channel show their author's name */
  publishAuthorName: Scalars['Boolean']['output'];
  /** Last update time, used by clients to cache-bust the channel image */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Whether the authenticated user follows this channel */
  viewerIsFollowing: Scalars['Boolean']['output'];
  /** Whether the authenticated user owns this channel */
  viewerIsOwner: Scalars['Boolean']['output'];
};

export type Competition = {
  __typename?: 'Competition';
  autonomousCommunity?: Maybe<AutonomousCommunity>;
  code: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * Official channels of the competition, sorted by name. Always a list (nullable
   * so clients building competition objects by hand do not need it)
   */
  officialChannels?: Maybe<Array<Channel>>;
  rank: Scalars['Int']['output'];
};

/** Autogenerated input type of CreateCareerEntry */
export type CreateCareerEntryInput = {
  /** An organization of the catalogue. Send it or organizationName */
  careerOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional free-text details (e.g. the category or league), up to 80 characters */
  details?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /**
   * Name typed by the user for an organization that is not in the catalogue. An
   * existing organization with that name is reused; otherwise an unregistered one is created
   */
  organizationName?: InputMaybe<Scalars['String']['input']>;
  role: CareerRoleEnum;
  /** Also registers the entry as the user's career status line. Only allowed for current entries (without end date). */
  setAsCareerStatus?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of CreateCareerEntry. */
export type CreateCareerEntryPayload = {
  __typename?: 'CreateCareerEntryPayload';
  careerEntry?: Maybe<CareerEntry>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateFantasyLeague */
export type CreateFantasyLeagueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Code of the competition the league plays. Defaults to 3RFEF2 */
  competitionCode?: InputMaybe<Scalars['String']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  maxPlayers?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /** Official channels of the league's competition that the creator wants to follow */
  officialChannelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of CreateFantasyLeague. */
export type CreateFantasyLeaguePayload = {
  __typename?: 'CreateFantasyLeaguePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  fantasyLeague?: Maybe<FantasyLeague>;
};

/** Autogenerated input type of CreateLeagueMessage */
export type CreateLeagueMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fantasyLeagueId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

/** Autogenerated return type of CreateLeagueMessage. */
export type CreateLeagueMessagePayload = {
  __typename?: 'CreateLeagueMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  fantasyLeagueMember?: Maybe<FantasyLeagueMember>;
  leagueMessage?: Maybe<LeagueMessage>;
};

/** Autogenerated input type of DeleteCareerEntry */
export type DeleteCareerEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCareerEntry. */
export type DeleteCareerEntryPayload = {
  __typename?: 'DeleteCareerEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteChannelImage */
export type DeleteChannelImageInput = {
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteChannelImage. */
export type DeleteChannelImagePayload = {
  __typename?: 'DeleteChannelImagePayload';
  channel?: Maybe<Channel>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteFantasyLeagueImage */
export type DeleteFantasyLeagueImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fantasyLeagueId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteFantasyLeagueImage. */
export type DeleteFantasyLeagueImagePayload = {
  __typename?: 'DeleteFantasyLeagueImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  fantasyLeague?: Maybe<FantasyLeague>;
};

/** Autogenerated input type of DeleteLeague */
export type DeleteLeagueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  leagueId: Scalars['ID']['input'];
};

/** Autogenerated input type of DeleteLeagueMessage */
export type DeleteLeagueMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  leagueMessageId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteLeagueMessage. */
export type DeleteLeagueMessagePayload = {
  __typename?: 'DeleteLeagueMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of DeleteLeague. */
export type DeleteLeaguePayload = {
  __typename?: 'DeleteLeaguePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeletePost */
export type DeletePostInput = {
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePost. */
export type DeletePostPayload = {
  __typename?: 'DeletePostPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteProfilePicture */
export type DeleteProfilePictureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteProfilePicture. */
export type DeleteProfilePicturePayload = {
  __typename?: 'DeleteProfilePicturePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  userAccount?: Maybe<UserAccount>;
};

/** Autogenerated input type of DeleteUserAccount */
export type DeleteUserAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteUserAccount. */
export type DeleteUserAccountPayload = {
  __typename?: 'DeleteUserAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Event = {
  __typename?: 'Event';
  createdAt: Scalars['ISO8601DateTime']['output'];
  eventType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  match: Match;
  minute: Scalars['Int']['output'];
  player: Player;
};

export type ExtendedPlayerInfo = {
  __typename?: 'ExtendedPlayerInfo';
  allSeasons: Array<Season>;
  marketValueHistory: Array<MarketValueHistoryPoint>;
  matchPlayersPerSeasonCompetition: Array<MatchPlayersGroup>;
  nextMatch?: Maybe<Match>;
  player: Player;
};

export type FantasyLeague = {
  __typename?: 'FantasyLeague';
  activeMarketEntries: Array<MarketEntry>;
  competition: Competition;
  createdAt: Scalars['ISO8601DateTime']['output'];
  creator?: Maybe<UserAccount>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isPublic: Scalars['Boolean']['output'];
  maxPlayers: Scalars['Int']['output'];
  members: Array<FantasyLeagueMember>;
  name: Scalars['String']['output'];
  participantsCount: Scalars['Int']['output'];
  secretCode: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  visibleBids: Array<Bid>;
};

export type FantasyLeagueMember = {
  __typename?: 'FantasyLeagueMember';
  /** Timestamp when the member last read the activity tab */
  activityLastReadAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  budget: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  fantasyLeague: FantasyLeague;
  /** All fantasy team players (the join records with IDs) */
  fantasyTeamPlayers: Array<FantasyTeamPlayer>;
  id: Scalars['ID']['output'];
  /** Timestamp when the member last read the messages tab */
  messagesLastReadAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  players: Array<Player>;
  role: Scalars['String']['output'];
  /** The players in the starting lineup, ordered by position */
  startingLineup: Array<FantasyTeamPlayer>;
  /** The chosen tactics/formation (e.g., '1-4-4-2') */
  tactics?: Maybe<Scalars['String']['output']>;
  teamName?: Maybe<Scalars['String']['output']>;
  /** Total number of unread items (events + messages) for this member */
  unreadActivityCount: Scalars['Int']['output'];
  /** Number of unread activity events for this member */
  unreadEventsCount: Scalars['Int']['output'];
  /** Number of unread messages for this member */
  unreadMessagesCount: Scalars['Int']['output'];
  user: UserAccount;
};

/** All fantasy team players for a fantasy league member */
export type FantasyLeagueMemberPlayers = {
  __typename?: 'FantasyLeagueMemberPlayers';
  /** All fantasy team players for this member */
  fantasyTeamPlayers: Array<FantasyTeamPlayer>;
  /** The formation tactics (e.g., '1-4-4-2') */
  tactics?: Maybe<Scalars['String']['output']>;
};

export type FantasyLeagueStanding = {
  __typename?: 'FantasyLeagueStanding';
  createdAt: Scalars['ISO8601DateTime']['output'];
  fantasyLeague: FantasyLeague;
  fantasyLeagueMember: FantasyLeagueMember;
  id: Scalars['ID']['output'];
  matchWeek: MatchWeek;
  position: Scalars['Int']['output'];
  totalScore: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FantasyTeamPlayer = {
  __typename?: 'FantasyTeamPlayer';
  createdAt: Scalars['ISO8601DateTime']['output'];
  fantasyLeagueMember: FantasyLeagueMember;
  id: Scalars['ID']['output'];
  /** True if within the 14-day individual protection window */
  individuallyProtected: Scalars['Boolean']['output'];
  player: Player;
  /** Current release clause amount in euros */
  releaseClause?: Maybe<Scalars['Int']['output']>;
  /** True if a release clause payment can currently be triggered for this player */
  releaseClausePayable: Scalars['Boolean']['output'];
  /** Date and time when the player was acquired */
  signedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Position in the starting lineup (0 = bench, 1-11 = starting position) */
  startingPosition: Scalars['Int']['output'];
  /** True if in the protection window before the next match week starts */
  weeklyWindowProtected: Scalars['Boolean']['output'];
};

/** Entity a piece of user feedback refers to */
export const FeedbackEntityTypeEnum = {
  /** Feedback about a match */
  Match: 'MATCH',
  /** Feedback about a player */
  Player: 'PLAYER'
} as const;

export type FeedbackEntityTypeEnum = typeof FeedbackEntityTypeEnum[keyof typeof FeedbackEntityTypeEnum];
/** Autogenerated input type of FollowChannel */
export type FollowChannelInput = {
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of FollowChannel. */
export type FollowChannelPayload = {
  __typename?: 'FollowChannelPayload';
  channel?: Maybe<Channel>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of GenerateChangePasswordUrl */
export type GenerateChangePasswordUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GenerateChangePasswordUrl. */
export type GenerateChangePasswordUrlPayload = {
  __typename?: 'GenerateChangePasswordUrlPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of IncreaseReleaseClause */
export type IncreaseReleaseClauseInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fantasyLeagueId: Scalars['ID']['input'];
  investmentAmount: Scalars['Int']['input'];
  playerId: Scalars['ID']['input'];
};

/** Autogenerated return type of IncreaseReleaseClause. */
export type IncreaseReleaseClausePayload = {
  __typename?: 'IncreaseReleaseClausePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  fantasyTeamPlayer?: Maybe<FantasyTeamPlayer>;
};

/** Autogenerated input type of JoinFantasyLeague */
export type JoinFantasyLeagueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  leagueId: Scalars['ID']['input'];
  /** Official channels of the league's competition that the user wants to follow */
  officialChannelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  secretCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of JoinFantasyLeague. */
export type JoinFantasyLeaguePayload = {
  __typename?: 'JoinFantasyLeaguePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  fantasyLeague?: Maybe<FantasyLeague>;
};

export type LeagueEvent = {
  __typename?: 'LeagueEvent';
  createdAt: Scalars['ISO8601DateTime']['output'];
  fantasyLeague: FantasyLeague;
  fantasyLeagueMember?: Maybe<FantasyLeagueMember>;
  fantasyTeamFrom?: Maybe<FantasyLeagueMember>;
  fantasyTeamTo?: Maybe<FantasyLeagueMember>;
  id: Scalars['ID']['output'];
  player?: Maybe<Player>;
  price?: Maybe<Scalars['Int']['output']>;
  releaseClause: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
};

export type LeagueMessage = {
  __typename?: 'LeagueMessage';
  createdAt: Scalars['ISO8601DateTime']['output'];
  fantasyLeague: FantasyLeague;
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<UserAccount>;
};

export type LeagueStanding = {
  __typename?: 'LeagueStanding';
  createdAt: Scalars['ISO8601DateTime']['output'];
  draws: Scalars['Int']['output'];
  goalDifference: Scalars['Int']['output'];
  goalsAgainst: Scalars['Int']['output'];
  goalsFor: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  losses: Scalars['Int']['output'];
  matchWeek: MatchWeek;
  played: Scalars['Int']['output'];
  points: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  stars: Scalars['Int']['output'];
  team: Team;
  wins: Scalars['Int']['output'];
};

/** Autogenerated input type of LeaveFantasyLeague */
export type LeaveFantasyLeagueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fantasyLeagueId: Scalars['ID']['input'];
};

/** Autogenerated return type of LeaveFantasyLeague. */
export type LeaveFantasyLeaguePayload = {
  __typename?: 'LeaveFantasyLeaguePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Lineup = {
  __typename?: 'Lineup';
  budget?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  fantasyLeagueMember: FantasyLeagueMember;
  id: Scalars['ID']['output'];
  lineupPlayers: Array<LineupPlayer>;
  matchWeek: MatchWeek;
  tactics?: Maybe<Scalars['String']['output']>;
  totalScore?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type LineupPlayer = {
  __typename?: 'LineupPlayer';
  /** The player's fantasy score, or null while it has not been calculated */
  calculatedFantasyScore?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  fantasyScore: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  player: Player;
  startingPosition: Scalars['Int']['output'];
};

/** Input for a player in the starting lineup */
export type LineupPlayerInput = {
  /** The ID of the FantasyTeamPlayer to place in the lineup */
  fantasyTeamPlayerId: Scalars['ID']['input'];
  /** The position in the lineup (1-11) */
  startingPosition: Scalars['Int']['input'];
};

export type MarketEntry = {
  __typename?: 'MarketEntry';
  /** Number of active bids for this market entry */
  bidCount: Scalars['Int']['output'];
  bids: Array<Bid>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fantasyLeague: FantasyLeague;
  id: Scalars['ID']['output'];
  listedAt: Scalars['ISO8601DateTime']['output'];
  player: Player;
  price: Scalars['Int']['output'];
  seller?: Maybe<FantasyLeagueMember>;
  soldTo?: Maybe<FantasyLeagueMember>;
  status: Scalars['String']['output'];
};

/** The daily market-hours restriction window. */
export type MarketHours = {
  __typename?: 'MarketHours';
  /** Time the market reopens (restriction ends), in "HH:MM" 24-hour Madrid time. */
  endTime: Scalars['String']['output'];
  /** Time the market closes (restriction starts), in "HH:MM" 24-hour Madrid time. */
  startTime: Scalars['String']['output'];
};

export type MarketValueHistoryPoint = {
  __typename?: 'MarketValueHistoryPoint';
  marketValue: Scalars['Int']['output'];
  validUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type Match = {
  __typename?: 'Match';
  awayTeam: Team;
  createdAt: Scalars['ISO8601DateTime']['output'];
  events: Array<Event>;
  goalsAway: Scalars['Int']['output'];
  goalsHome: Scalars['Int']['output'];
  homeTeam: Team;
  id: Scalars['ID']['output'];
  lockGoals: Scalars['Boolean']['output'];
  matchDate: Scalars['ISO8601DateTime']['output'];
  matchPlayers: Array<MatchPlayer>;
  matchWeek: MatchWeek;
  statsCalculatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: Scalars['String']['output'];
};

export type MatchPlayer = {
  __typename?: 'MatchPlayer';
  createdAt: Scalars['ISO8601DateTime']['output'];
  fantasyScore?: Maybe<Scalars['Float']['output']>;
  fantasyScoreDetails?: Maybe<Scalars['String']['output']>;
  goals: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  match: Match;
  minutesPlayed: Scalars['Int']['output'];
  ownGoals: Scalars['Int']['output'];
  penaltyGoals: Scalars['Int']['output'];
  player: Player;
  redCard: Scalars['Boolean']['output'];
  rivalGoals: Scalars['Int']['output'];
  starterPosition: Scalars['Boolean']['output'];
  team: Team;
  teamGoals: Scalars['Int']['output'];
  yellowCards: Scalars['Int']['output'];
};

export type MatchPlayersGroup = {
  __typename?: 'MatchPlayersGroup';
  /** Average fantasy score over the player's last 5 started match weeks of this competition (missed weeks count as 0) */
  lastFiveAverage?: Maybe<Scalars['Float']['output']>;
  matchPlayers: Array<MatchPlayer>;
  /** Average real-world points the player's current team earns per match when the player is on the pitch */
  onPitchPointsPerMatch?: Maybe<Scalars['Float']['output']>;
  seasonCompetition: SeasonCompetitionInfo;
  /** Average real-world points the player's current team earns per match when the player is a starter */
  starterPointsPerMatch?: Maybe<Scalars['Float']['output']>;
  /** Average real-world league points the player's team earns per match in this season competition */
  teamPointsPerMatch?: Maybe<Scalars['Float']['output']>;
};

export type MatchWeek = {
  __typename?: 'MatchWeek';
  createdAt: Scalars['ISO8601DateTime']['output'];
  endDate: Scalars['ISO8601Date']['output'];
  id: Scalars['ID']['output'];
  startDate: Scalars['ISO8601Date']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  weekNumber: Scalars['Int']['output'];
};

export type MatchWeekMatches = {
  __typename?: 'MatchWeekMatches';
  currentMatchWeek: MatchWeek;
  hasNext: Scalars['Boolean']['output'];
  hasPrevious: Scalars['Boolean']['output'];
  /** Matches for the match week */
  matches: Array<Match>;
  nextMatchWeekId?: Maybe<Scalars['ID']['output']>;
  previousMatchWeekId?: Maybe<Scalars['ID']['output']>;
  seasonCompetitionId: Scalars['ID']['output'];
  /** League standings for the match week */
  standings: Array<LeagueStanding>;
};

export type MatchWeekScores = {
  __typename?: 'MatchWeekScores';
  /** The match week being displayed */
  currentMatchWeek: MatchWeek;
  /** Whether there's a next match week available */
  hasNext: Scalars['Boolean']['output'];
  /** Whether there's a previous match week available */
  hasPrevious: Scalars['Boolean']['output'];
  /** Lineups for the match week, ordered by total_score DESC */
  lineups: Array<Lineup>;
  /** ID of the next match week (null if none) */
  nextMatchWeekId?: Maybe<Scalars['ID']['output']>;
  /** ID of the previous match week (null if none) */
  previousMatchWeekId?: Maybe<Scalars['ID']['output']>;
  /** Standings for the previous match week (empty if no previous week exists) */
  previousStandings: Array<FantasyLeagueStanding>;
  /** Standings for the match week, ordered by position ASC */
  standings: Array<FantasyLeagueStanding>;
};

/** A player and the fantasy score they got in a match week */
export type MatchWeekTopPlayer = {
  __typename?: 'MatchWeekTopPlayer';
  fantasyScore: Scalars['Float']['output'];
  player: Player;
};

/** Best scoring players of each position in a match week */
export type MatchWeekTopPlayers = {
  __typename?: 'MatchWeekTopPlayers';
  matchWeek: MatchWeek;
  /** Best scoring players of each position, ordered by fantasy score */
  players: Array<MatchWeekTopPlayer>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Registra un token de dispositivo para notificaciones push */
  addDeviceToUser?: Maybe<AddDeviceToUserPayload>;
  /** Adds a player to the market for sale */
  addPlayerToMarket?: Maybe<AddPlayerToMarketPayload>;
  /** Creates a career-history entry for the authenticated user */
  createCareerEntry?: Maybe<CreateCareerEntryPayload>;
  /** Creates a new fantasy league */
  createFantasyLeague?: Maybe<CreateFantasyLeaguePayload>;
  /** Crea un mensaje en una liga para un miembro de la liga */
  createLeagueMessage?: Maybe<CreateLeagueMessagePayload>;
  /** Deletes a career-history entry of the authenticated user */
  deleteCareerEntry?: Maybe<DeleteCareerEntryPayload>;
  /** Removes the image of a channel. Only the channel owner can do it */
  deleteChannelImage?: Maybe<DeleteChannelImagePayload>;
  /** Removes the image of a fantasy league. Only the creator and admins can do it */
  deleteFantasyLeagueImage?: Maybe<DeleteFantasyLeagueImagePayload>;
  /** Deletes a fantasy league (admin/creator only) */
  deleteLeague?: Maybe<DeleteLeaguePayload>;
  /** Borra un mensaje de liga escrito por el usuario autenticado */
  deleteLeagueMessage?: Maybe<DeleteLeagueMessagePayload>;
  /** Deletes a post from the authenticated user's channel */
  deletePost?: Maybe<DeletePostPayload>;
  /** Removes the current user's profile picture */
  deleteProfilePicture?: Maybe<DeleteProfilePicturePayload>;
  /** Deletes the authenticated user's account */
  deleteUserAccount?: Maybe<DeleteUserAccountPayload>;
  /** Makes the authenticated user follow a channel */
  followChannel?: Maybe<FollowChannelPayload>;
  /** Generate an Auth0 change password URL for the current user */
  generateChangePasswordUrl?: Maybe<GenerateChangePasswordUrlPayload>;
  /** Invests part of a member's budget to increase one of their players' release clause (1 € → +2 € on clause) */
  increaseReleaseClause?: Maybe<IncreaseReleaseClausePayload>;
  /** Allows a user to join an existing fantasy league */
  joinFantasyLeague?: Maybe<JoinFantasyLeaguePayload>;
  /** The current user leaves a fantasy league they belong to */
  leaveFantasyLeague?: Maybe<LeaveFantasyLeaguePayload>;
  /** Places a bid for a player on sale in the market */
  placeBid?: Maybe<PlaceBidPayload>;
  /** Places or updates a direct transfer offer for a player not currently on the market */
  placeTransferOffer?: Maybe<PlaceTransferOfferPayload>;
  /** Publishes a post for the authenticated user's channel */
  publishPost?: Maybe<PublishPostPayload>;
  /** Removes a member from a fantasy league (admin/creator only) */
  removeFantasyLeagueMember?: Maybe<RemoveFantasyLeagueMemberPayload>;
  /** Removes a player from the market by cancelling the market entry */
  removePlayerFromMarket?: Maybe<RemovePlayerFromMarketPayload>;
  /**
   * Reports a league message, post or comment as inappropriate. Succeeds as well
   * when the content had already been reviewed, without telling the user.
   */
  reportUserContent?: Maybe<ReportUserContentPayload>;
  /** Resets all teams in a fantasy league (admin/creator only) */
  resetTeams?: Maybe<ResetTeamsPayload>;
  /** Rotates the secret code of a private fantasy league (admin/creator only) */
  rotateSecretCode?: Maybe<RotateSecretCodePayload>;
  /** Creates or updates a draft post for the authenticated user's channel */
  saveDraftPost?: Maybe<SaveDraftPostPayload>;
  /** Sends user feedback about a player or a match to the FutyClub team */
  sendFeedback?: Maybe<SendFeedbackPayload>;
  /** An example field added by the generator */
  testField: Scalars['String']['output'];
  /** Pays the release clause of a player, forcibly transferring them to the buyer */
  triggerReleaseClausePayment?: Maybe<TriggerReleaseClausePaymentPayload>;
  /** Makes the authenticated user stop following a channel */
  unfollowChannel?: Maybe<UnfollowChannelPayload>;
  /** Desvincula un token de dispositivo al cerrar sesión */
  unlinkDevice?: Maybe<UnlinkDevicePayload>;
  /** Actualiza el timestamp de última lectura de actividad para un miembro de la liga */
  updateActivityLastRead?: Maybe<UpdateActivityLastReadPayload>;
  /** Updates the status of a bid (accept or reject) */
  updateBidStatus?: Maybe<UpdateBidStatusPayload>;
  /** Updates a career-history entry of the authenticated user */
  updateCareerEntry?: Maybe<UpdateCareerEntryPayload>;
  /** Updates the career status line shown on the authenticated user's profile. A blank value clears it. */
  updateCareerStatus?: Maybe<UpdateCareerStatusPayload>;
  /** Updates the authenticated user's channel and its configuration */
  updateChannel?: Maybe<UpdateChannelPayload>;
  /** Updates an existing fantasy league configuration */
  updateFantasyLeague?: Maybe<UpdateFantasyLeaguePayload>;
  /** Updates the admin list of a fantasy league (admin/creator only) */
  updateLeagueAdmins?: Maybe<UpdateLeagueAdminsPayload>;
  /** Edita un mensaje de liga escrito por el usuario autenticado */
  updateLeagueMessage?: Maybe<UpdateLeagueMessagePayload>;
  /** Updates the starting lineup for a fantasy league member */
  updateLineup?: Maybe<UpdateLineupPayload>;
  /** Actualiza el timestamp de última lectura de mensajes para un miembro de la liga */
  updateMessagesLastRead?: Maybe<UpdateMessagesLastReadPayload>;
  /** Actualiza el nombre del equipo de un miembro de la liga */
  updateTeamName?: Maybe<UpdateTeamNamePayload>;
  /** Accepts or rejects a direct transfer offer (only the target member can do this) */
  updateTransferOfferStatus?: Maybe<UpdateTransferOfferStatusPayload>;
  /** Updates the current user's account information */
  updateUserAccount?: Maybe<UpdateUserAccountPayload>;
  /** Uploads an image for a channel. Only the channel owner can do it */
  uploadChannelImage?: Maybe<UploadChannelImagePayload>;
  /** Uploads an image for a fantasy league. Only the creator and admins can do it */
  uploadFantasyLeagueImage?: Maybe<UploadFantasyLeagueImagePayload>;
  /** Uploads a profile picture for the current user */
  uploadProfilePicture?: Maybe<UploadProfilePicturePayload>;
  /** Withdraws a bid for a player on sale in the market */
  withdrawBid?: Maybe<WithdrawBidPayload>;
  /** Withdraws an active direct transfer offer (only the bidder can do this) */
  withdrawTransferOffer?: Maybe<WithdrawTransferOfferPayload>;
};


export type MutationAddDeviceToUserArgs = {
  input: AddDeviceToUserInput;
};


export type MutationAddPlayerToMarketArgs = {
  input: AddPlayerToMarketInput;
};


export type MutationCreateCareerEntryArgs = {
  input: CreateCareerEntryInput;
};


export type MutationCreateFantasyLeagueArgs = {
  input: CreateFantasyLeagueInput;
};


export type MutationCreateLeagueMessageArgs = {
  input: CreateLeagueMessageInput;
};


export type MutationDeleteCareerEntryArgs = {
  input: DeleteCareerEntryInput;
};


export type MutationDeleteChannelImageArgs = {
  input: DeleteChannelImageInput;
};


export type MutationDeleteFantasyLeagueImageArgs = {
  input: DeleteFantasyLeagueImageInput;
};


export type MutationDeleteLeagueArgs = {
  input: DeleteLeagueInput;
};


export type MutationDeleteLeagueMessageArgs = {
  input: DeleteLeagueMessageInput;
};


export type MutationDeletePostArgs = {
  input: DeletePostInput;
};


export type MutationDeleteProfilePictureArgs = {
  input: DeleteProfilePictureInput;
};


export type MutationDeleteUserAccountArgs = {
  input: DeleteUserAccountInput;
};


export type MutationFollowChannelArgs = {
  input: FollowChannelInput;
};


export type MutationGenerateChangePasswordUrlArgs = {
  input: GenerateChangePasswordUrlInput;
};


export type MutationIncreaseReleaseClauseArgs = {
  input: IncreaseReleaseClauseInput;
};


export type MutationJoinFantasyLeagueArgs = {
  input: JoinFantasyLeagueInput;
};


export type MutationLeaveFantasyLeagueArgs = {
  input: LeaveFantasyLeagueInput;
};


export type MutationPlaceBidArgs = {
  input: PlaceBidInput;
};


export type MutationPlaceTransferOfferArgs = {
  input: PlaceTransferOfferInput;
};


export type MutationPublishPostArgs = {
  input: PublishPostInput;
};


export type MutationRemoveFantasyLeagueMemberArgs = {
  input: RemoveFantasyLeagueMemberInput;
};


export type MutationRemovePlayerFromMarketArgs = {
  input: RemovePlayerFromMarketInput;
};


export type MutationReportUserContentArgs = {
  input: ReportUserContentInput;
};


export type MutationResetTeamsArgs = {
  input: ResetTeamsInput;
};


export type MutationRotateSecretCodeArgs = {
  input: RotateSecretCodeInput;
};


export type MutationSaveDraftPostArgs = {
  input: SaveDraftPostInput;
};


export type MutationSendFeedbackArgs = {
  input: SendFeedbackInput;
};


export type MutationTriggerReleaseClausePaymentArgs = {
  input: TriggerReleaseClausePaymentInput;
};


export type MutationUnfollowChannelArgs = {
  input: UnfollowChannelInput;
};


export type MutationUnlinkDeviceArgs = {
  input: UnlinkDeviceInput;
};


export type MutationUpdateActivityLastReadArgs = {
  input: UpdateActivityLastReadInput;
};


export type MutationUpdateBidStatusArgs = {
  input: UpdateBidStatusInput;
};


export type MutationUpdateCareerEntryArgs = {
  input: UpdateCareerEntryInput;
};


export type MutationUpdateCareerStatusArgs = {
  input: UpdateCareerStatusInput;
};


export type MutationUpdateChannelArgs = {
  input: UpdateChannelInput;
};


export type MutationUpdateFantasyLeagueArgs = {
  input: UpdateFantasyLeagueInput;
};


export type MutationUpdateLeagueAdminsArgs = {
  input: UpdateLeagueAdminsInput;
};


export type MutationUpdateLeagueMessageArgs = {
  input: UpdateLeagueMessageInput;
};


export type MutationUpdateLineupArgs = {
  input: UpdateLineupInput;
};


export type MutationUpdateMessagesLastReadArgs = {
  input: UpdateMessagesLastReadInput;
};


export type MutationUpdateTeamNameArgs = {
  input: UpdateTeamNameInput;
};


export type MutationUpdateTransferOfferStatusArgs = {
  input: UpdateTransferOfferStatusInput;
};


export type MutationUpdateUserAccountArgs = {
  input: UpdateUserAccountInput;
};


export type MutationUploadChannelImageArgs = {
  input: UploadChannelImageInput;
};


export type MutationUploadFantasyLeagueImageArgs = {
  input: UploadFantasyLeagueImageInput;
};


export type MutationUploadProfilePictureArgs = {
  input: UploadProfilePictureInput;
};


export type MutationWithdrawBidArgs = {
  input: WithdrawBidInput;
};


export type MutationWithdrawTransferOfferArgs = {
  input: WithdrawTransferOfferInput;
};

/** A photo added to a post when it is saved */
export type NewPostPhotoInput = {
  /** image/jpeg, image/png or image/webp */
  contentType: Scalars['String']['input'];
  /** The image, base64 encoded */
  imageBase64: Scalars['String']['input'];
  /**
   * Unique key chosen by the app for this photo (e.g. a UUID). Send the same key
   * when retrying a save, so the photo is not added twice
   */
  uploadKey: Scalars['ID']['input'];
};

/** Autogenerated input type of PlaceBid */
export type PlaceBidInput = {
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  marketEntryId: Scalars['ID']['input'];
};

/** Autogenerated return type of PlaceBid. */
export type PlaceBidPayload = {
  __typename?: 'PlaceBidPayload';
  bid?: Maybe<Bid>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of PlaceTransferOffer */
export type PlaceTransferOfferInput = {
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fantasyLeagueId: Scalars['ID']['input'];
  playerId: Scalars['ID']['input'];
};

/** Autogenerated return type of PlaceTransferOffer. */
export type PlaceTransferOfferPayload = {
  __typename?: 'PlaceTransferOfferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  transferOffer?: Maybe<TransferOffer>;
};

export type Player = {
  __typename?: 'Player';
  birthDate?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastWeekNumber?: Maybe<Scalars['Int']['output']>;
  lastWeekScore?: Maybe<Scalars['Float']['output']>;
  marketValue?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nick: Scalars['String']['output'];
  previousMarketValue?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<PlayerRoleEnum>;
  team?: Maybe<Team>;
  totalScore?: Maybe<Scalars['Float']['output']>;
};

/** Player position/role on the field */
export const PlayerRoleEnum = {
  /** Midfielder (Centrocampista) */
  Centrocampista: 'CENTROCAMPISTA',
  /** Defender (Defensa) */
  Defensa: 'DEFENSA',
  /** Forward (Delantero) */
  Delantero: 'DELANTERO',
  /** Goalkeeper (Portero) */
  Portero: 'PORTERO'
} as const;

export type PlayerRoleEnum = typeof PlayerRoleEnum[keyof typeof PlayerRoleEnum];
export type Post = {
  __typename?: 'Post';
  author?: Maybe<UserAccount>;
  channel?: Maybe<Channel>;
  /** Whether the post can still be edited (drafts always; published within the 1h window) */
  editable: Scalars['Boolean']['output'];
  /** When a published post was last edited after publication; null if never edited */
  editedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** Optional title shown instead of the bare related link URL */
  linkTitle?: Maybe<Scalars['String']['output']>;
  /** Optional related link (absolute http/https URL) shown after the post text */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** Photos shown under the post, in upload order (at most appConfig.postMaxPhotos) */
  photos: Array<PostPhoto>;
  publishedAt: Scalars['ISO8601DateTime']['output'];
  /** Lifecycle state: draft, published or archived */
  status: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type PostPhoto = {
  __typename?: 'PostPhoto';
  id: Scalars['ID']['output'];
  /** Public URL of the photo */
  url: Scalars['String']['output'];
};

export type PublicFantasyLeagueMemberInfo = {
  __typename?: 'PublicFantasyLeagueMemberInfo';
  fantasyLeagueMemberId: Scalars['ID']['output'];
  players: Array<Player>;
  teamName?: Maybe<Scalars['String']['output']>;
};

export type PublicUserProfile = {
  __typename?: 'PublicUserProfile';
  /** The user's career history, current roles first */
  careerEntries: Array<CareerEntry>;
  /** Career status line shown on the profile, e.g. 'Jugador de Avilés Stadium' */
  careerStatus?: Maybe<Scalars['String']['output']>;
  /** Channels owned by the user */
  channels: Array<Channel>;
  /** Name the user is known by. When present, clients show it instead of the full name */
  displayName?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  /** Last update time, used by clients to cache-bust the profile picture */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A page of public user profiles */
export type PublicUserProfilesPage = {
  __typename?: 'PublicUserProfilesPage';
  /** Number of profiles requested */
  limit: Scalars['Int']['output'];
  /** Current offset in pagination */
  offset: Scalars['Int']['output'];
  profiles: Array<PublicUserProfile>;
  /** Total number of matching profiles */
  totalCount: Scalars['Int']['output'];
};

/** Autogenerated input type of PublishPost */
export type PublishPostInput = {
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional title shown instead of the bare related link URL */
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional related link (absolute http/https URL). Omit to keep the current one; null clears it */
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  /** Photos added after the kept ones, saved together with the text */
  newPhotos?: InputMaybe<Array<NewPostPhotoInput>>;
  /** The post's current photos to keep, in order; the rest are removed. Omit to keep them all */
  photoIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  postId?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of PublishPost. */
export type PublishPostPayload = {
  __typename?: 'PublishPostPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  post?: Maybe<Post>;
};

export type Query = {
  __typename?: 'Query';
  /** Returns active market entries for a specific fantasy league */
  activeMarketEntries: Array<MarketEntry>;
  /**
   * Returns the backend-served application configuration, so the frontend does not
   * hardcode values that may need to change without a mobile release.
   */
  appConfig: AppConfig;
  /**
   * Returns a page of the other users that were in the organization of a career
   * entry during its period. Neither the entry's owner nor the authenticated user are included.
   */
  careerEntryOverlaps?: Maybe<CareerEntryOverlaps>;
  /**
   * Paginated directory of registered career organizations. Without a term (or
   * with a blank one) it lists them alphabetically; with a term it searches them
   * by name (full-text, word prefixes), most relevant first.
   */
  careerOrganizationDirectory?: Maybe<CareerOrganizationsPage>;
  /**
   * Returns a page of the users linked to a career organization: those currently
   * in it (a career entry without end date) or those that were in it in the past
   * and are not anymore. Returns null for an unknown organization.
   */
  careerOrganizationProfiles?: Maybe<CareerOrganizationProfiles>;
  /** Searches registered career organizations by name using the full-text index */
  careerOrganizations: Array<CareerOrganization>;
  /** Returns any channel by id for the authenticated user */
  channel?: Maybe<Channel>;
  /** Returns the draft posts of a channel, newest first, only to its owner */
  channelDrafts: Array<Post>;
  /** Returns the most recent published posts from a single channel, newest first */
  channelPosts: Array<Post>;
  /** Returns the most recent published posts from the channels the authenticated user follows or owns, newest first */
  channelTimeline: Array<Post>;
  /** Returns the authenticated user's membership in a fantasy league */
  currentFantasyLeagueMember?: Maybe<FantasyLeagueMember>;
  /** Returns the authenticated league member's active market entries */
  currentFantasyLeagueMemberActiveMarketEntries: Array<MarketEntry>;
  /** Returns list of enabled feature flags for the current user */
  enabledFeatureFlags: Array<Scalars['String']['output']>;
  /** Returns a fantasy league by ID */
  fantasyLeague?: Maybe<FantasyLeague>;
  /** Returns league events for a specific fantasy league, ordered by most recent first */
  fantasyLeagueEvents: Array<LeagueEvent>;
  /** Returns match week scores (lineups and standings) for a fantasy league */
  fantasyLeagueMatchWeekScores?: Maybe<MatchWeekScores>;
  /**
   * Returns past (non-active) bids for the current user in a specific fantasy
   * league, where the user is either the bidder or the seller, ordered by most recent first
   */
  fantasyLeagueMemberPastBids: Array<Bid>;
  /**
   * Returns past (non-active) transfer offers for the current user in a specific
   * fantasy league, where the user is either the bidder or the target member,
   * ordered by most recent first
   */
  fantasyLeagueMemberPastTransferOffers: Array<TransferOffer>;
  /** Returns all fantasy team players for a fantasy league member */
  fantasyLeagueMemberPlayers?: Maybe<FantasyLeagueMemberPlayers>;
  /** Returns the competitions the current user can create fantasy leagues for */
  getAvailableCompetitions: Array<Competition>;
  /** Returns extended player information including match history */
  getExtendedPlayerInfo?: Maybe<ExtendedPlayerInfo>;
  /** Returns detailed information for a specific match */
  getMatch?: Maybe<Match>;
  /** Returns matches and standings for a match week */
  getMatches?: Maybe<MatchWeekMatches>;
  /** Returns the roster of a team for a specific season competition */
  getSeasonCompetitionTeamRoster?: Maybe<SeasonCompetitionTeam>;
  /** Returns the list of teams for a season competition */
  getSeasonCompetitionTeams?: Maybe<SeasonCompetitionTeams>;
  /** Returns the season competitions available to the current user */
  getSeasonCompetitions: Array<SeasonCompetition>;
  /** Returns the seasons with at least one competition available to the current user */
  getSeasons: Array<Season>;
  /** Returns team information with roster */
  getTeam?: Maybe<Team>;
  /** Returns the first MatchWeek whose start_date is greater than today */
  getUpcomingMatchWeek?: Maybe<MatchWeek>;
  /** Returns league messages for a specific fantasy league, ordered by most recent first */
  leagueMessages: Array<LeagueMessage>;
  /** Returns the legal content (T&C and Privacy Policy) as an HTML string */
  legalContent: Scalars['String']['output'];
  /** Returns the best scoring players of each position in a match week (global admins only) */
  matchWeekTopPlayers?: Maybe<MatchWeekTopPlayers>;
  /** Returns the authenticated user's career history */
  myCareerEntries: Array<CareerEntry>;
  /** Returns one of the authenticated user's own channels */
  myChannel?: Maybe<Channel>;
  /** Returns every channel owned by the authenticated user */
  myChannels: Array<Channel>;
  /** Returns the lineup for a fantasy league member for a specific match week */
  pastLeagueMemberLineup?: Maybe<Lineup>;
  /** Returns a single post by ID, if the authenticated user is allowed to see it */
  post?: Maybe<Post>;
  /** Returns public information about a fantasy league member (team name and players) */
  publicFantasyLeagueMemberInfo?: Maybe<PublicFantasyLeagueMemberInfo>;
  /** Returns the public profile of any user */
  publicUserProfile?: Maybe<PublicUserProfile>;
  /** Search channels by name or description (case- and accent-insensitive partial match). */
  searchChannels: SearchChannelsResult;
  /**
   * Search fantasy leagues by name (case-insensitive partial match). With a blank
   * search term it lists the public leagues, so users can discover them.
   */
  searchFantasyLeagues: SearchFantasyLeaguesResult;
  /**
   * Searches public profiles by name (full-text, word prefixes). Without a term
   * (or with a blank one) it lists the users that share a fantasy league with the
   * authenticated user. The authenticated user is never included.
   */
  searchPublicProfiles?: Maybe<PublicUserProfilesPage>;
  /** An example field added by the generator */
  testField: Scalars['String']['output'];
  /** Returns the authenticated user's account */
  userAccount?: Maybe<UserAccount>;
  /** Returns visible bids for the current user in a specific fantasy league */
  visibleBids: Array<Bid>;
  /**
   * Returns active transfer offers for the current user in a specific fantasy
   * league, where the user is either the bidder or the target member
   */
  visibleTransferOffers: Array<TransferOffer>;
};


export type QueryActiveMarketEntriesArgs = {
  fantasyLeagueId: Scalars['ID']['input'];
};


export type QueryCareerEntryOverlapsArgs = {
  careerEntryId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCareerOrganizationDirectoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCareerOrganizationProfilesArgs = {
  careerOrganizationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  period: CareerOrganizationProfilesPeriodEnum;
};


export type QueryCareerOrganizationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
};


export type QueryChannelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChannelDraftsArgs = {
  channelId: Scalars['ID']['input'];
};


export type QueryChannelPostsArgs = {
  channelId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChannelTimelineArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCurrentFantasyLeagueMemberArgs = {
  fantasyLeagueId: Scalars['ID']['input'];
};


export type QueryCurrentFantasyLeagueMemberActiveMarketEntriesArgs = {
  fantasyLeagueId: Scalars['ID']['input'];
};


export type QueryFantasyLeagueArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFantasyLeagueEventsArgs = {
  fantasyLeagueId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFantasyLeagueMatchWeekScoresArgs = {
  fantasyLeagueId: Scalars['ID']['input'];
  matchWeekId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryFantasyLeagueMemberPastBidsArgs = {
  fantasyLeagueId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFantasyLeagueMemberPastTransferOffersArgs = {
  fantasyLeagueId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFantasyLeagueMemberPlayersArgs = {
  fantasyLeagueMemberId: Scalars['ID']['input'];
};


export type QueryGetExtendedPlayerInfoArgs = {
  playerId: Scalars['ID']['input'];
  seasonCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetMatchArgs = {
  matchId: Scalars['ID']['input'];
};


export type QueryGetMatchesArgs = {
  matchWeekId?: InputMaybe<Scalars['ID']['input']>;
  seasonCompetitionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetSeasonCompetitionTeamRosterArgs = {
  seasonCompetitionTeamId: Scalars['ID']['input'];
};


export type QueryGetSeasonCompetitionTeamsArgs = {
  seasonCompetitionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetSeasonCompetitionsArgs = {
  seasonId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetTeamArgs = {
  teamId: Scalars['ID']['input'];
};


export type QueryGetUpcomingMatchWeekArgs = {
  seasonCompetitionId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLeagueMessagesArgs = {
  fantasyLeagueId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMatchWeekTopPlayersArgs = {
  matchWeekId: Scalars['ID']['input'];
};


export type QueryMyChannelArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPastLeagueMemberLineupArgs = {
  fantasyLeagueMemberId: Scalars['ID']['input'];
  matchWeekId: Scalars['ID']['input'];
};


export type QueryPostArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicFantasyLeagueMemberInfoArgs = {
  fantasyLeagueMemberId: Scalars['ID']['input'];
};


export type QueryPublicUserProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySearchChannelsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  term: Scalars['String']['input'];
};


export type QuerySearchFantasyLeaguesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchPublicProfilesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserAccountArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVisibleBidsArgs = {
  fantasyLeagueId: Scalars['ID']['input'];
};


export type QueryVisibleTransferOffersArgs = {
  fantasyLeagueId: Scalars['ID']['input'];
};

/** Autogenerated input type of RemoveFantasyLeagueMember */
export type RemoveFantasyLeagueMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fantasyLeagueMemberId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveFantasyLeagueMember. */
export type RemoveFantasyLeagueMemberPayload = {
  __typename?: 'RemoveFantasyLeagueMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemovePlayerFromMarket */
export type RemovePlayerFromMarketInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  marketEntryId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemovePlayerFromMarket. */
export type RemovePlayerFromMarketPayload = {
  __typename?: 'RemovePlayerFromMarketPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ReportUserContent */
export type ReportUserContentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentId: Scalars['ID']['input'];
  contentType: UserContentTypeEnum;
  reason: UserContentReportReasonEnum;
};

/** Autogenerated return type of ReportUserContent. */
export type ReportUserContentPayload = {
  __typename?: 'ReportUserContentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResetTeams */
export type ResetTeamsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  leagueId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResetTeams. */
export type ResetTeamsPayload = {
  __typename?: 'ResetTeamsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  fantasyLeague?: Maybe<FantasyLeague>;
};

/** Autogenerated input type of RotateSecretCode */
export type RotateSecretCodeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fantasyLeagueId: Scalars['ID']['input'];
};

/** Autogenerated return type of RotateSecretCode. */
export type RotateSecretCodePayload = {
  __typename?: 'RotateSecretCodePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  fantasyLeague?: Maybe<FantasyLeague>;
};

/** Autogenerated input type of SaveDraftPost */
export type SaveDraftPostInput = {
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional title shown instead of the bare related link URL */
  linkTitle?: InputMaybe<Scalars['String']['input']>;
  /** Optional related link (absolute http/https URL). Omit to keep the current one; null clears it */
  linkUrl?: InputMaybe<Scalars['String']['input']>;
  /** Photos added after the kept ones, saved together with the text */
  newPhotos?: InputMaybe<Array<NewPostPhotoInput>>;
  /** The post's current photos to keep, in order; the rest are removed. Omit to keep them all */
  photoIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  postId?: InputMaybe<Scalars['ID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveDraftPost. */
export type SaveDraftPostPayload = {
  __typename?: 'SaveDraftPostPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  post?: Maybe<Post>;
};

export type SearchChannelsResult = {
  __typename?: 'SearchChannelsResult';
  /** Array of channels matching the search */
  channels: Array<Channel>;
  /** Number of results returned */
  limit: Scalars['Int']['output'];
  /** Current offset in pagination */
  offset: Scalars['Int']['output'];
  /** Total number of channels matching the search */
  totalCount: Scalars['Int']['output'];
};

export type SearchFantasyLeaguesResult = {
  __typename?: 'SearchFantasyLeaguesResult';
  /** Array of fantasy leagues matching the search */
  leagues: Array<FantasyLeague>;
  /** Number of results returned */
  limit: Scalars['Int']['output'];
  /** Current offset in pagination */
  offset: Scalars['Int']['output'];
  /** Total number of leagues matching the search */
  totalCount: Scalars['Int']['output'];
};

export type Season = {
  __typename?: 'Season';
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type SeasonCompetition = {
  __typename?: 'SeasonCompetition';
  active: Scalars['Boolean']['output'];
  competition: Competition;
  id: Scalars['ID']['output'];
  season: Season;
};

export type SeasonCompetitionInfo = {
  __typename?: 'SeasonCompetitionInfo';
  competition: Competition;
  id: Scalars['ID']['output'];
};

export type SeasonCompetitionTeam = {
  __typename?: 'SeasonCompetitionTeam';
  id: Scalars['ID']['output'];
  players: Array<Player>;
  seasonCompetition: SeasonCompetition;
  team: Team;
};

export type SeasonCompetitionTeams = {
  __typename?: 'SeasonCompetitionTeams';
  seasonCompetition: SeasonCompetition;
  teams: Array<SeasonCompetitionTeam>;
};

/** Autogenerated input type of SendFeedback */
export type SendFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
  entityType: FeedbackEntityTypeEnum;
  text: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendFeedback. */
export type SendFeedbackPayload = {
  __typename?: 'SendFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Team = {
  __typename?: 'Team';
  /**
   * Competition the team plays in during the active season. Null when the team is
   * not registered in any active season competition.
   */
  competition?: Maybe<Competition>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  nameShow: Scalars['String']['output'];
  players?: Maybe<Array<Player>>;
  shield?: Maybe<Scalars['String']['output']>;
  shieldBig?: Maybe<Scalars['String']['output']>;
  shieldPng?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
};

export type TransferOffer = {
  __typename?: 'TransferOffer';
  amount: Scalars['Int']['output'];
  bidder: FantasyLeagueMember;
  createdAt: Scalars['ISO8601DateTime']['output'];
  fantasyLeague: FantasyLeague;
  id: Scalars['ID']['output'];
  player: Player;
  releaseClause: Scalars['Boolean']['output'];
  seller: FantasyLeagueMember;
  status: Scalars['String']['output'];
};

/** Autogenerated input type of TriggerReleaseClausePayment */
export type TriggerReleaseClausePaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fantasyLeagueId: Scalars['ID']['input'];
  playerId: Scalars['ID']['input'];
};

/** Autogenerated return type of TriggerReleaseClausePayment. */
export type TriggerReleaseClausePaymentPayload = {
  __typename?: 'TriggerReleaseClausePaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  transferOffer?: Maybe<TransferOffer>;
};

/** Autogenerated input type of UnfollowChannel */
export type UnfollowChannelInput = {
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UnfollowChannel. */
export type UnfollowChannelPayload = {
  __typename?: 'UnfollowChannelPayload';
  channel?: Maybe<Channel>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UnlinkDevice */
export type UnlinkDeviceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Token del dispositivo FCM/APNS a desvincular */
  token: Scalars['String']['input'];
};

/** Autogenerated return type of UnlinkDevice. */
export type UnlinkDevicePayload = {
  __typename?: 'UnlinkDevicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateActivityLastRead */
export type UpdateActivityLastReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fantasyLeagueMemberId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateActivityLastRead. */
export type UpdateActivityLastReadPayload = {
  __typename?: 'UpdateActivityLastReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  fantasyLeagueMember?: Maybe<FantasyLeagueMember>;
};

/** Autogenerated input type of UpdateBidStatus */
export type UpdateBidStatusInput = {
  bidId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newStatus: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateBidStatus. */
export type UpdateBidStatusPayload = {
  __typename?: 'UpdateBidStatusPayload';
  bid?: Maybe<Bid>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCareerEntry */
export type UpdateCareerEntryInput = {
  /** An organization of the catalogue. Send it or organizationName */
  careerOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional free-text details (e.g. the category or league), up to 80 characters.
   * Omit it to keep the current details; send null to remove them
   */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Omit it or send null for a current role */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  id: Scalars['ID']['input'];
  /**
   * Name typed by the user for an organization that is not in the catalogue. An
   * existing organization with that name is reused; otherwise an unregistered one is created
   */
  organizationName?: InputMaybe<Scalars['String']['input']>;
  role: CareerRoleEnum;
  startDate: Scalars['ISO8601Date']['input'];
};

/** Autogenerated return type of UpdateCareerEntry. */
export type UpdateCareerEntryPayload = {
  __typename?: 'UpdateCareerEntryPayload';
  careerEntry?: Maybe<CareerEntry>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCareerStatus */
export type UpdateCareerStatusInput = {
  careerStatus?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCareerStatus. */
export type UpdateCareerStatusPayload = {
  __typename?: 'UpdateCareerStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  userAccount?: Maybe<UserAccount>;
};

/** Autogenerated input type of UpdateChannel */
export type UpdateChannelInput = {
  allowComments?: InputMaybe<Scalars['Boolean']['input']>;
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishAuthorName?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateChannel. */
export type UpdateChannelPayload = {
  __typename?: 'UpdateChannelPayload';
  channel?: Maybe<Channel>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateFantasyLeague */
export type UpdateFantasyLeagueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fantasyLeagueId: Scalars['ID']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  maxPlayers?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateFantasyLeague. */
export type UpdateFantasyLeaguePayload = {
  __typename?: 'UpdateFantasyLeaguePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  fantasyLeague?: Maybe<FantasyLeague>;
};

/** Autogenerated input type of UpdateLeagueAdmins */
export type UpdateLeagueAdminsInput = {
  adminMemberIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fantasyLeagueId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateLeagueAdmins. */
export type UpdateLeagueAdminsPayload = {
  __typename?: 'UpdateLeagueAdminsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateLeagueMessage */
export type UpdateLeagueMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  leagueMessageId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateLeagueMessage. */
export type UpdateLeagueMessagePayload = {
  __typename?: 'UpdateLeagueMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  leagueMessage?: Maybe<LeagueMessage>;
};

/** Autogenerated input type of UpdateLineup */
export type UpdateLineupInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the fantasy league member */
  fantasyLeagueMemberId: Scalars['ID']['input'];
  /** The list of players in the starting lineup with their positions */
  lineupPlayers: Array<LineupPlayerInput>;
  /** The chosen tactics/formation (e.g., '1-4-4-2') */
  tactics: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateLineup. */
export type UpdateLineupPayload = {
  __typename?: 'UpdateLineupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateMessagesLastRead */
export type UpdateMessagesLastReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fantasyLeagueMemberId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateMessagesLastRead. */
export type UpdateMessagesLastReadPayload = {
  __typename?: 'UpdateMessagesLastReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  fantasyLeagueMember?: Maybe<FantasyLeagueMember>;
};

/** Autogenerated input type of UpdateTeamName */
export type UpdateTeamNameInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fantasyLeagueMemberId: Scalars['ID']['input'];
  teamName: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateTeamName. */
export type UpdateTeamNamePayload = {
  __typename?: 'UpdateTeamNamePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  fantasyLeagueMember?: Maybe<FantasyLeagueMember>;
};

/** Autogenerated input type of UpdateTransferOfferStatus */
export type UpdateTransferOfferStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newStatus: Scalars['String']['input'];
  transferOfferId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateTransferOfferStatus. */
export type UpdateTransferOfferStatusPayload = {
  __typename?: 'UpdateTransferOfferStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  transferOffer?: Maybe<TransferOffer>;
};

/** Autogenerated input type of UpdateUserAccount */
export type UpdateUserAccountInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Name the user is known by. Unlike the other fields, a blank value or null clears it */
  displayName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUserAccount. */
export type UpdateUserAccountPayload = {
  __typename?: 'UpdateUserAccountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  userAccount?: Maybe<UserAccount>;
};

/** Autogenerated input type of UploadChannelImage */
export type UploadChannelImageInput = {
  channelId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  imageBase64: Scalars['String']['input'];
};

/** Autogenerated return type of UploadChannelImage. */
export type UploadChannelImagePayload = {
  __typename?: 'UploadChannelImagePayload';
  channel?: Maybe<Channel>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UploadFantasyLeagueImage */
export type UploadFantasyLeagueImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  fantasyLeagueId: Scalars['ID']['input'];
  imageBase64: Scalars['String']['input'];
};

/** Autogenerated return type of UploadFantasyLeagueImage. */
export type UploadFantasyLeagueImagePayload = {
  __typename?: 'UploadFantasyLeagueImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  fantasyLeague?: Maybe<FantasyLeague>;
};

/** Autogenerated input type of UploadProfilePicture */
export type UploadProfilePictureInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  imageBase64: Scalars['String']['input'];
};

/** Autogenerated return type of UploadProfilePicture. */
export type UploadProfilePicturePayload = {
  __typename?: 'UploadProfilePicturePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  userAccount?: Maybe<UserAccount>;
};

export type UserAccount = {
  __typename?: 'UserAccount';
  /** Career status line shown on the profile, e.g. 'Jugador de Avilés Stadium' */
  careerStatus?: Maybe<Scalars['String']['output']>;
  complete: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Name the user is known by. When present, clients show it instead of the full name */
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailVerified?: Maybe<Scalars['Boolean']['output']>;
  fantasyLeagueMembers: Array<FantasyLeagueMember>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  roles: Array<Scalars['String']['output']>;
  sub: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Reason why a user reports a content as inappropriate */
export const UserContentReportReasonEnum = {
  /** Harassment or insults */
  Harassment: 'HARASSMENT',
  /** Hate speech */
  HateSpeech: 'HATE_SPEECH',
  /** False information */
  Misinformation: 'MISINFORMATION',
  /** Any other reason */
  Other: 'OTHER',
  /** Sexual content */
  SexualContent: 'SEXUAL_CONTENT',
  /** Spam or advertising */
  Spam: 'SPAM',
  /** Violence or threats */
  Violence: 'VIOLENCE'
} as const;

export type UserContentReportReasonEnum = typeof UserContentReportReasonEnum[keyof typeof UserContentReportReasonEnum];
/** Type of user content that can be reported */
export const UserContentTypeEnum = {
  /** A comment on a post */
  Comment: 'COMMENT',
  /** A message of a fantasy league */
  LeagueMessage: 'LEAGUE_MESSAGE',
  /** A post of a channel */
  Post: 'POST'
} as const;

export type UserContentTypeEnum = typeof UserContentTypeEnum[keyof typeof UserContentTypeEnum];
/** Autogenerated input type of WithdrawBid */
export type WithdrawBidInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  marketEntryId: Scalars['ID']['input'];
};

/** Autogenerated return type of WithdrawBid. */
export type WithdrawBidPayload = {
  __typename?: 'WithdrawBidPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of WithdrawTransferOffer */
export type WithdrawTransferOfferInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  transferOfferId: Scalars['ID']['input'];
};

/** Autogenerated return type of WithdrawTransferOffer. */
export type WithdrawTransferOfferPayload = {
  __typename?: 'WithdrawTransferOfferPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  transferOffer?: Maybe<TransferOffer>;
};

export type PostCardFieldsFragment = { __typename?: 'Post', id: string, text: string, publishedAt: string, editedAt?: string | null, linkUrl?: string | null, linkTitle?: string | null, photos: Array<{ __typename?: 'PostPhoto', id: string, url: string }>, author?: { __typename?: 'UserAccount', id: string, fullName?: string | null } | null, channel?: { __typename?: 'Channel', id: string, name: string, image?: string | null, updatedAt: string, publishAuthorName: boolean } | null };

export type PublicProfileCardFieldsFragment = { __typename?: 'PublicUserProfile', id: string, fullName?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, picture?: string | null, updatedAt: string, careerStatus?: string | null };

export type CreateCareerEntryMutationVariables = Exact<{
  input: CreateCareerEntryInput;
}>;


export type CreateCareerEntryMutation = { __typename?: 'Mutation', createCareerEntry?: { __typename?: 'CreateCareerEntryPayload', errors: Array<string>, careerEntry?: { __typename?: 'CareerEntry', id: string, role: CareerRoleEnum, startDate: any, endDate?: any | null, details?: string | null, careerOrganization: { __typename?: 'CareerOrganization', id: string, name: string } } | null } | null };

export type UpdateCareerEntryMutationVariables = Exact<{
  input: UpdateCareerEntryInput;
}>;


export type UpdateCareerEntryMutation = { __typename?: 'Mutation', updateCareerEntry?: { __typename?: 'UpdateCareerEntryPayload', errors: Array<string>, careerEntry?: { __typename?: 'CareerEntry', id: string, role: CareerRoleEnum, startDate: any, endDate?: any | null, details?: string | null, careerOrganization: { __typename?: 'CareerOrganization', id: string, name: string } } | null } | null };

export type UpdateCareerStatusMutationVariables = Exact<{
  input: UpdateCareerStatusInput;
}>;


export type UpdateCareerStatusMutation = { __typename?: 'Mutation', updateCareerStatus?: { __typename?: 'UpdateCareerStatusPayload', errors: Array<string>, userAccount?: { __typename?: 'UserAccount', id: string, careerStatus?: string | null } | null } | null };

export type DeleteCareerEntryMutationVariables = Exact<{
  input: DeleteCareerEntryInput;
}>;


export type DeleteCareerEntryMutation = { __typename?: 'Mutation', deleteCareerEntry?: { __typename?: 'DeleteCareerEntryPayload', success: boolean, errors: Array<string> } | null };

export type UploadChannelImageMutationVariables = Exact<{
  channelId: Scalars['ID']['input'];
  imageBase64: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
}>;


export type UploadChannelImageMutation = { __typename?: 'Mutation', uploadChannelImage?: { __typename?: 'UploadChannelImagePayload', errors: Array<string>, channel?: { __typename?: 'Channel', id: string, image?: string | null, updatedAt: string } | null } | null };

export type DeleteChannelImageMutationVariables = Exact<{
  channelId: Scalars['ID']['input'];
}>;


export type DeleteChannelImageMutation = { __typename?: 'Mutation', deleteChannelImage?: { __typename?: 'DeleteChannelImagePayload', errors: Array<string>, channel?: { __typename?: 'Channel', id: string, image?: string | null, updatedAt: string } | null } | null };

export type CreateFantasyLeagueMutationVariables = Exact<{
  input: CreateFantasyLeagueInput;
}>;


export type CreateFantasyLeagueMutation = { __typename?: 'Mutation', createFantasyLeague?: { __typename?: 'CreateFantasyLeaguePayload', errors: Array<string>, fantasyLeague?: { __typename?: 'FantasyLeague', id: string, name: string, isPublic: boolean, maxPlayers: number, secretCode: string, participantsCount: number, creator?: { __typename?: 'UserAccount', id: string, fullName?: string | null } | null } | null } | null };

export type CreateLeagueMessageMutationVariables = Exact<{
  input: CreateLeagueMessageInput;
}>;


export type CreateLeagueMessageMutation = { __typename?: 'Mutation', createLeagueMessage?: { __typename?: 'CreateLeagueMessagePayload', errors: Array<string>, leagueMessage?: { __typename?: 'LeagueMessage', id: string, text: string, createdAt: string, user?: { __typename?: 'UserAccount', id: string, fullName?: string | null } | null } | null, fantasyLeagueMember?: { __typename?: 'FantasyLeagueMember', id: string, messagesLastReadAt?: string | null, unreadMessagesCount: number } | null } | null };

export type DeleteLeagueMessageMutationVariables = Exact<{
  input: DeleteLeagueMessageInput;
}>;


export type DeleteLeagueMessageMutation = { __typename?: 'Mutation', deleteLeagueMessage?: { __typename?: 'DeleteLeagueMessagePayload', success: boolean, errors: Array<string> } | null };

export type DeletePostMutationVariables = Exact<{
  input: DeletePostInput;
}>;


export type DeletePostMutation = { __typename?: 'Mutation', deletePost?: { __typename?: 'DeletePostPayload', success: boolean, errors: Array<string> } | null };

export type DeleteUserAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteUserAccountMutation = { __typename?: 'Mutation', deleteUserAccount?: { __typename?: 'DeleteUserAccountPayload', success: boolean, errors: Array<string> } | null };

export type UploadFantasyLeagueImageMutationVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
  imageBase64: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
}>;


export type UploadFantasyLeagueImageMutation = { __typename?: 'Mutation', uploadFantasyLeagueImage?: { __typename?: 'UploadFantasyLeagueImagePayload', errors: Array<string>, fantasyLeague?: { __typename?: 'FantasyLeague', id: string, image?: string | null, updatedAt: string } | null } | null };

export type DeleteFantasyLeagueImageMutationVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
}>;


export type DeleteFantasyLeagueImageMutation = { __typename?: 'Mutation', deleteFantasyLeagueImage?: { __typename?: 'DeleteFantasyLeagueImagePayload', errors: Array<string>, fantasyLeague?: { __typename?: 'FantasyLeague', id: string, image?: string | null, updatedAt: string } | null } | null };

export type UpdateTeamNameMutationVariables = Exact<{
  fantasyLeagueMemberId: Scalars['ID']['input'];
  teamName: Scalars['String']['input'];
}>;


export type UpdateTeamNameMutation = { __typename?: 'Mutation', updateTeamName?: { __typename?: 'UpdateTeamNamePayload', errors: Array<string>, fantasyLeagueMember?: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null } | null } | null };

export type FollowChannelMutationVariables = Exact<{
  input: FollowChannelInput;
}>;


export type FollowChannelMutation = { __typename?: 'Mutation', followChannel?: { __typename?: 'FollowChannelPayload', errors: Array<string>, channel?: { __typename?: 'Channel', id: string, followersCount: number, viewerIsFollowing: boolean } | null } | null };

export type UnfollowChannelMutationVariables = Exact<{
  input: UnfollowChannelInput;
}>;


export type UnfollowChannelMutation = { __typename?: 'Mutation', unfollowChannel?: { __typename?: 'UnfollowChannelPayload', errors: Array<string>, channel?: { __typename?: 'Channel', id: string, followersCount: number, viewerIsFollowing: boolean } | null } | null };

export type GenerateChangePasswordUrlMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateChangePasswordUrlMutation = { __typename?: 'Mutation', generateChangePasswordUrl?: { __typename?: 'GenerateChangePasswordUrlPayload', url?: string | null, errors: Array<string> } | null };

export type JoinFantasyLeagueMutationVariables = Exact<{
  input: JoinFantasyLeagueInput;
}>;


export type JoinFantasyLeagueMutation = { __typename?: 'Mutation', joinFantasyLeague?: { __typename?: 'JoinFantasyLeaguePayload', errors: Array<string>, fantasyLeague?: { __typename?: 'FantasyLeague', id: string, name: string, isPublic: boolean, participantsCount: number, creator?: { __typename?: 'UserAccount', id: string, fullName?: string | null } | null } | null } | null };

export type ResetTeamsMutationVariables = Exact<{
  input: ResetTeamsInput;
}>;


export type ResetTeamsMutation = { __typename?: 'Mutation', resetTeams?: { __typename?: 'ResetTeamsPayload', errors: Array<string>, fantasyLeague?: { __typename?: 'FantasyLeague', id: string, name: string, members: Array<{ __typename?: 'FantasyLeagueMember', id: string, budget: number, players: Array<{ __typename?: 'Player', id: string, nick: string, name?: string | null, lastName?: string | null, role?: PlayerRoleEnum | null, marketValue?: number | null, image?: string | null, team?: { __typename?: 'Team', id: string, nameShow: string, shortName?: string | null, shield?: string | null } | null }> }> } | null } | null };

export type DeleteLeagueMutationVariables = Exact<{
  input: DeleteLeagueInput;
}>;


export type DeleteLeagueMutation = { __typename?: 'Mutation', deleteLeague?: { __typename?: 'DeleteLeaguePayload', success: boolean, errors: Array<string> } | null };

export type RemoveFantasyLeagueMemberMutationVariables = Exact<{
  input: RemoveFantasyLeagueMemberInput;
}>;


export type RemoveFantasyLeagueMemberMutation = { __typename?: 'Mutation', removeFantasyLeagueMember?: { __typename?: 'RemoveFantasyLeagueMemberPayload', success: boolean, errors: Array<string> } | null };

export type UpdateLeagueAdminsMutationVariables = Exact<{
  input: UpdateLeagueAdminsInput;
}>;


export type UpdateLeagueAdminsMutation = { __typename?: 'Mutation', updateLeagueAdmins?: { __typename?: 'UpdateLeagueAdminsPayload', success: boolean, errors: Array<string> } | null };

export type RotateSecretCodeMutationVariables = Exact<{
  input: RotateSecretCodeInput;
}>;


export type RotateSecretCodeMutation = { __typename?: 'Mutation', rotateSecretCode?: { __typename?: 'RotateSecretCodePayload', errors: Array<string>, fantasyLeague?: { __typename?: 'FantasyLeague', id: string, secretCode: string } | null } | null };

export type LeaveFantasyLeagueMutationVariables = Exact<{
  input: LeaveFantasyLeagueInput;
}>;


export type LeaveFantasyLeagueMutation = { __typename?: 'Mutation', leaveFantasyLeague?: { __typename?: 'LeaveFantasyLeaguePayload', success: boolean, errors: Array<string> } | null };

export type AddPlayerToMarketMutationVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
  playerId: Scalars['ID']['input'];
  price: Scalars['Int']['input'];
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;


export type AddPlayerToMarketMutation = { __typename?: 'Mutation', addPlayerToMarket?: { __typename?: 'AddPlayerToMarketPayload', errors: Array<string>, marketEntry?: { __typename?: 'MarketEntry', id: string, price: number, status: string, listedAt: string, expiresAt?: string | null, player: { __typename?: 'Player', id: string, nick: string, role?: PlayerRoleEnum | null, marketValue?: number | null, team?: { __typename?: 'Team', id: string, nameShow: string, shortName?: string | null, competition?: { __typename?: 'Competition', id: string, code: string, displayName: string, rank: number } | null } | null } } | null } | null };

export type PlaceBidMutationVariables = Exact<{
  marketEntryId: Scalars['ID']['input'];
  amount: Scalars['Int']['input'];
}>;


export type PlaceBidMutation = { __typename?: 'Mutation', placeBid?: { __typename?: 'PlaceBidPayload', errors: Array<string>, bid?: { __typename?: 'Bid', id: string, amount: number, createdAt: string, marketEntry: { __typename?: 'MarketEntry', id: string }, bidder?: { __typename?: 'FantasyLeagueMember', id: string, user: { __typename?: 'UserAccount', id: string, fullName?: string | null } } | null } | null } | null };

export type WithdrawBidMutationVariables = Exact<{
  marketEntryId: Scalars['ID']['input'];
}>;


export type WithdrawBidMutation = { __typename?: 'Mutation', withdrawBid?: { __typename?: 'WithdrawBidPayload', success: boolean, errors: Array<string> } | null };

export type UpdateBidStatusMutationVariables = Exact<{
  bidId: Scalars['ID']['input'];
  newStatus: Scalars['String']['input'];
}>;


export type UpdateBidStatusMutation = { __typename?: 'Mutation', updateBidStatus?: { __typename?: 'UpdateBidStatusPayload', errors: Array<string>, bid?: { __typename?: 'Bid', id: string, status: string, amount: number, marketEntry: { __typename?: 'MarketEntry', id: string, status: string } } | null } | null };

export type RemovePlayerFromMarketMutationVariables = Exact<{
  marketEntryId: Scalars['ID']['input'];
}>;


export type RemovePlayerFromMarketMutation = { __typename?: 'Mutation', removePlayerFromMarket?: { __typename?: 'RemovePlayerFromMarketPayload', success: boolean, errors: Array<string> } | null };

export type UploadProfilePictureMutationVariables = Exact<{
  imageBase64: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
}>;


export type UploadProfilePictureMutation = { __typename?: 'Mutation', uploadProfilePicture?: { __typename?: 'UploadProfilePicturePayload', errors: Array<string>, userAccount?: { __typename?: 'UserAccount', id: string, picture?: string | null } | null } | null };

export type DeleteProfilePictureMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteProfilePictureMutation = { __typename?: 'Mutation', deleteProfilePicture?: { __typename?: 'DeleteProfilePicturePayload', errors: Array<string>, userAccount?: { __typename?: 'UserAccount', id: string, picture?: string | null } | null } | null };

export type PublishPostMutationVariables = Exact<{
  input: PublishPostInput;
}>;


export type PublishPostMutation = { __typename?: 'Mutation', publishPost?: { __typename?: 'PublishPostPayload', errors: Array<string>, post?: { __typename?: 'Post', id: string, text: string, status: string, editedAt?: string | null, editable: boolean, linkUrl?: string | null, linkTitle?: string | null, photos: Array<{ __typename?: 'PostPhoto', id: string, url: string }> } | null } | null };

export type AddDeviceToUserMutationVariables = Exact<{
  input: AddDeviceToUserInput;
}>;


export type AddDeviceToUserMutation = { __typename?: 'Mutation', addDeviceToUser?: { __typename?: 'AddDeviceToUserPayload', success: boolean, errors: Array<string> } | null };

export type UnlinkDeviceMutationVariables = Exact<{
  input: UnlinkDeviceInput;
}>;


export type UnlinkDeviceMutation = { __typename?: 'Mutation', unlinkDevice?: { __typename?: 'UnlinkDevicePayload', success: boolean, errors: Array<string> } | null };

export type TriggerReleaseClausePaymentMutationVariables = Exact<{
  input: TriggerReleaseClausePaymentInput;
}>;


export type TriggerReleaseClausePaymentMutation = { __typename?: 'Mutation', triggerReleaseClausePayment?: { __typename?: 'TriggerReleaseClausePaymentPayload', errors: Array<string>, transferOffer?: { __typename?: 'TransferOffer', id: string, amount: number, status: string, releaseClause: boolean } | null } | null };

export type IncreaseReleaseClauseMutationVariables = Exact<{
  input: IncreaseReleaseClauseInput;
}>;


export type IncreaseReleaseClauseMutation = { __typename?: 'Mutation', increaseReleaseClause?: { __typename?: 'IncreaseReleaseClausePayload', errors: Array<string>, fantasyTeamPlayer?: { __typename?: 'FantasyTeamPlayer', id: string, releaseClause?: number | null } | null } | null };

export type ReportUserContentMutationVariables = Exact<{
  input: ReportUserContentInput;
}>;


export type ReportUserContentMutation = { __typename?: 'Mutation', reportUserContent?: { __typename?: 'ReportUserContentPayload', success: boolean, errors: Array<string> } | null };

export type SaveDraftPostMutationVariables = Exact<{
  input: SaveDraftPostInput;
}>;


export type SaveDraftPostMutation = { __typename?: 'Mutation', saveDraftPost?: { __typename?: 'SaveDraftPostPayload', errors: Array<string>, post?: { __typename?: 'Post', id: string, text: string, status: string, editedAt?: string | null, editable: boolean, linkUrl?: string | null, linkTitle?: string | null, photos: Array<{ __typename?: 'PostPhoto', id: string, url: string }> } | null } | null };

export type SendFeedbackMutationVariables = Exact<{
  entityType: FeedbackEntityTypeEnum;
  entityId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type SendFeedbackMutation = { __typename?: 'Mutation', sendFeedback?: { __typename?: 'SendFeedbackPayload', success: boolean, errors: Array<string> } | null };

export type PlaceTransferOfferMutationVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
  playerId: Scalars['ID']['input'];
  amount: Scalars['Int']['input'];
}>;


export type PlaceTransferOfferMutation = { __typename?: 'Mutation', placeTransferOffer?: { __typename?: 'PlaceTransferOfferPayload', errors: Array<string>, transferOffer?: { __typename?: 'TransferOffer', id: string, amount: number, status: string, createdAt: string, player: { __typename?: 'Player', id: string, nick: string }, bidder: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null }, seller: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null } } | null } | null };

export type UpdateTransferOfferStatusMutationVariables = Exact<{
  transferOfferId: Scalars['ID']['input'];
  newStatus: Scalars['String']['input'];
}>;


export type UpdateTransferOfferStatusMutation = { __typename?: 'Mutation', updateTransferOfferStatus?: { __typename?: 'UpdateTransferOfferStatusPayload', errors: Array<string>, transferOffer?: { __typename?: 'TransferOffer', id: string, status: string, amount: number, player: { __typename?: 'Player', id: string, nick: string } } | null } | null };

export type WithdrawTransferOfferMutationVariables = Exact<{
  transferOfferId: Scalars['ID']['input'];
}>;


export type WithdrawTransferOfferMutation = { __typename?: 'Mutation', withdrawTransferOffer?: { __typename?: 'WithdrawTransferOfferPayload', errors: Array<string>, transferOffer?: { __typename?: 'TransferOffer', id: string, status: string } | null } | null };

export type UpdateActivityLastReadMutationVariables = Exact<{
  input: UpdateActivityLastReadInput;
}>;


export type UpdateActivityLastReadMutation = { __typename?: 'Mutation', updateActivityLastRead?: { __typename?: 'UpdateActivityLastReadPayload', errors: Array<string>, fantasyLeagueMember?: { __typename?: 'FantasyLeagueMember', id: string, activityLastReadAt?: string | null, unreadActivityCount: number } | null } | null };

export type UpdateChannelMutationVariables = Exact<{
  input: UpdateChannelInput;
}>;


export type UpdateChannelMutation = { __typename?: 'Mutation', updateChannel?: { __typename?: 'UpdateChannelPayload', errors: Array<string>, channel?: { __typename?: 'Channel', id: string, name: string, description?: string | null, allowComments: boolean, publishAuthorName: boolean, followersCount: number } | null } | null };

export type UpdateFantasyLeagueMutationVariables = Exact<{
  input: UpdateFantasyLeagueInput;
}>;


export type UpdateFantasyLeagueMutation = { __typename?: 'Mutation', updateFantasyLeague?: { __typename?: 'UpdateFantasyLeaguePayload', errors: Array<string>, fantasyLeague?: { __typename?: 'FantasyLeague', id: string, name: string, isPublic: boolean, maxPlayers: number } | null } | null };

export type UpdateLeagueMessageMutationVariables = Exact<{
  input: UpdateLeagueMessageInput;
}>;


export type UpdateLeagueMessageMutation = { __typename?: 'Mutation', updateLeagueMessage?: { __typename?: 'UpdateLeagueMessagePayload', errors: Array<string>, leagueMessage?: { __typename?: 'LeagueMessage', id: string, text: string, createdAt: string, user?: { __typename?: 'UserAccount', id: string, fullName?: string | null } | null } | null } | null };

export type UpdateLineupMutationVariables = Exact<{
  input: UpdateLineupInput;
}>;


export type UpdateLineupMutation = { __typename?: 'Mutation', updateLineup?: { __typename?: 'UpdateLineupPayload', errors: Array<string> } | null };

export type UpdateMessagesLastReadMutationVariables = Exact<{
  input: UpdateMessagesLastReadInput;
}>;


export type UpdateMessagesLastReadMutation = { __typename?: 'Mutation', updateMessagesLastRead?: { __typename?: 'UpdateMessagesLastReadPayload', errors: Array<string>, fantasyLeagueMember?: { __typename?: 'FantasyLeagueMember', id: string, messagesLastReadAt?: string | null, unreadMessagesCount: number, unreadEventsCount: number, unreadActivityCount: number } | null } | null };

export type UpdateUserAccountMutationVariables = Exact<{
  input: UpdateUserAccountInput;
}>;


export type UpdateUserAccountMutation = { __typename?: 'Mutation', updateUserAccount?: { __typename?: 'UpdateUserAccountPayload', errors: Array<string>, userAccount?: { __typename?: 'UserAccount', id: string, email: string, sub: string, emailVerified?: boolean | null, name?: string | null, picture?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, displayName?: string | null, roles: Array<string>, createdAt: string, updatedAt: string } | null } | null };

export type GetActiveMarketEntriesQueryVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
}>;


export type GetActiveMarketEntriesQuery = { __typename?: 'Query', activeMarketEntries: Array<{ __typename?: 'MarketEntry', id: string, price: number, status: string, listedAt: string, expiresAt?: string | null, bidCount: number, player: { __typename?: 'Player', id: string, createdAt: string, nick: string, name?: string | null, lastName?: string | null, role?: PlayerRoleEnum | null, marketValue?: number | null, image?: string | null, totalScore?: number | null, lastWeekScore?: number | null, lastWeekNumber?: number | null, team?: { __typename?: 'Team', id: string, createdAt: string, nameShow: string, shortName?: string | null, shield?: string | null, competition?: { __typename?: 'Competition', id: string, code: string, displayName: string, rank: number } | null } | null }, seller?: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null, user: { __typename?: 'UserAccount', id: string, fullName?: string | null } } | null }> };

export type GetAppConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppConfigQuery = { __typename?: 'Query', appConfig: { __typename?: 'AppConfig', postMaxTextLength: number, postMaxLinkTitleLength: number, postMaxPhotos: number, marketHours: { __typename?: 'MarketHours', startTime: string, endTime: string } } };

export type GetMyCareerEntriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCareerEntriesQuery = { __typename?: 'Query', myCareerEntries: Array<{ __typename?: 'CareerEntry', id: string, role: CareerRoleEnum, startDate: any, endDate?: any | null, details?: string | null, careerOrganization: { __typename?: 'CareerOrganization', id: string, name: string } }> };

export type SearchCareerOrganizationsQueryVariables = Exact<{
  term: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchCareerOrganizationsQuery = { __typename?: 'Query', careerOrganizations: Array<{ __typename?: 'CareerOrganization', id: string, name: string }> };

export type GetChannelQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetChannelQuery = { __typename?: 'Query', channel?: { __typename?: 'Channel', id: string, name: string, description?: string | null, image?: string | null, updatedAt: string, followersCount: number, viewerIsOwner: boolean, viewerIsFollowing: boolean } | null };

export type GetChannelDraftsQueryVariables = Exact<{
  channelId: Scalars['ID']['input'];
}>;


export type GetChannelDraftsQuery = { __typename?: 'Query', channelDrafts: Array<{ __typename?: 'Post', id: string, text: string, status: string, publishedAt: string }> };

export type GetMyChannelFollowersQueryVariables = Exact<{
  channelId: Scalars['ID']['input'];
}>;


export type GetMyChannelFollowersQuery = { __typename?: 'Query', myChannel?: { __typename?: 'Channel', id: string, followersCount: number, followers: Array<{ __typename?: 'UserAccount', id: string, fullName?: string | null, picture?: string | null, updatedAt: string }> } | null };

export type GetChannelPostsQueryVariables = Exact<{
  channelId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetChannelPostsQuery = { __typename?: 'Query', channelPosts: Array<{ __typename?: 'Post', id: string, text: string, publishedAt: string, editedAt?: string | null, linkUrl?: string | null, linkTitle?: string | null, photos: Array<{ __typename?: 'PostPhoto', id: string, url: string }>, author?: { __typename?: 'UserAccount', id: string, fullName?: string | null } | null, channel?: { __typename?: 'Channel', id: string, name: string, image?: string | null, updatedAt: string, publishAuthorName: boolean } | null }> };

export type GetChannelTimelineQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetChannelTimelineQuery = { __typename?: 'Query', channelTimeline: Array<{ __typename?: 'Post', id: string, text: string, publishedAt: string, editedAt?: string | null, linkUrl?: string | null, linkTitle?: string | null, photos: Array<{ __typename?: 'PostPhoto', id: string, url: string }>, author?: { __typename?: 'UserAccount', id: string, fullName?: string | null } | null, channel?: { __typename?: 'Channel', id: string, name: string, image?: string | null, updatedAt: string, publishAuthorName: boolean } | null }> };

export type GetCurrentFantasyLeagueMemberQueryVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
}>;


export type GetCurrentFantasyLeagueMemberQuery = { __typename?: 'Query', currentFantasyLeagueMember?: { __typename?: 'FantasyLeagueMember', id: string, budget: number } | null };

export type GetCurrentFantasyLeagueMemberActiveMarketEntriesQueryVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
}>;


export type GetCurrentFantasyLeagueMemberActiveMarketEntriesQuery = { __typename?: 'Query', currentFantasyLeagueMemberActiveMarketEntries: Array<{ __typename?: 'MarketEntry', id: string, player: { __typename?: 'Player', id: string } }> };

export type GetEnabledFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEnabledFeatureFlagsQuery = { __typename?: 'Query', enabledFeatureFlags: Array<string> };

export type GetExtendedPlayerInfoQueryVariables = Exact<{
  playerId: Scalars['ID']['input'];
  seasonCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetExtendedPlayerInfoQuery = { __typename?: 'Query', getExtendedPlayerInfo?: { __typename?: 'ExtendedPlayerInfo', player: { __typename?: 'Player', id: string, nick: string, name?: string | null, lastName?: string | null, role?: PlayerRoleEnum | null, image?: string | null, marketValue?: number | null, previousMarketValue?: number | null, team?: { __typename?: 'Team', id: string, fullName?: string | null, shortName?: string | null, nameShow: string, shield?: string | null, createdAt: string, competition?: { __typename?: 'Competition', id: string, code: string, displayName: string, rank: number } | null } | null }, nextMatch?: { __typename?: 'Match', id: string, matchDate: string, status: string, matchWeek: { __typename?: 'MatchWeek', id: string, weekNumber: number }, homeTeam: { __typename?: 'Team', id: string, nameShow: string, shield?: string | null }, awayTeam: { __typename?: 'Team', id: string, nameShow: string, shield?: string | null } } | null, marketValueHistory: Array<{ __typename?: 'MarketValueHistoryPoint', marketValue: number, validUntil?: string | null }>, allSeasons: Array<{ __typename?: 'Season', id: string, code: string, displayName: string, active: boolean }>, matchPlayersPerSeasonCompetition: Array<{ __typename?: 'MatchPlayersGroup', teamPointsPerMatch?: number | null, lastFiveAverage?: number | null, onPitchPointsPerMatch?: number | null, starterPointsPerMatch?: number | null, seasonCompetition: { __typename?: 'SeasonCompetitionInfo', id: string, competition: { __typename?: 'Competition', id: string, displayName: string, code: string } }, matchPlayers: Array<{ __typename?: 'MatchPlayer', id: string, minutesPlayed: number, goals: number, penaltyGoals: number, yellowCards: number, redCard: boolean, teamGoals: number, rivalGoals: number, fantasyScore?: number | null, match: { __typename?: 'Match', id: string, goalsHome: number, goalsAway: number, matchDate: string, matchWeek: { __typename?: 'MatchWeek', id: string, weekNumber: number }, homeTeam: { __typename?: 'Team', id: string, shortName?: string | null }, awayTeam: { __typename?: 'Team', id: string, shortName?: string | null } } }> }> } | null };

export type GetFantasyLeagueQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFantasyLeagueQuery = { __typename?: 'Query', fantasyLeague?: { __typename?: 'FantasyLeague', id: string, name: string, isPublic: boolean, secretCode: string, maxPlayers: number, image?: string | null, participantsCount: number, createdAt: string, updatedAt: string, creator?: { __typename?: 'UserAccount', id: string, fullName?: string | null, picture?: string | null } | null, members: Array<{ __typename?: 'FantasyLeagueMember', id: string, role: string, budget: number, teamName?: string | null, activityLastReadAt?: string | null, messagesLastReadAt?: string | null, unreadEventsCount: number, unreadMessagesCount: number, unreadActivityCount: number, user: { __typename?: 'UserAccount', id: string, fullName?: string | null, picture?: string | null, updatedAt: string }, fantasyTeamPlayers: Array<{ __typename?: 'FantasyTeamPlayer', id: string, createdAt: string, startingPosition: number, releaseClause?: number | null, signedAt?: string | null, individuallyProtected: boolean, weeklyWindowProtected: boolean, releaseClausePayable: boolean, fantasyLeagueMember: { __typename?: 'FantasyLeagueMember', id: string }, player: { __typename?: 'Player', id: string, createdAt: string, nick: string, name?: string | null, lastName?: string | null, role?: PlayerRoleEnum | null, marketValue?: number | null, image?: string | null, totalScore?: number | null, lastWeekScore?: number | null, lastWeekNumber?: number | null, team?: { __typename?: 'Team', id: string, createdAt: string, nameShow: string, shortName?: string | null, shield?: string | null, competition?: { __typename?: 'Competition', id: string, code: string, displayName: string, rank: number } | null } | null } }> }>, activeMarketEntries: Array<{ __typename?: 'MarketEntry', id: string, price: number, status: string, listedAt: string, expiresAt?: string | null, player: { __typename?: 'Player', id: string, createdAt: string, nick: string, name?: string | null, lastName?: string | null, role?: PlayerRoleEnum | null, marketValue?: number | null, image?: string | null, totalScore?: number | null, lastWeekScore?: number | null, lastWeekNumber?: number | null, team?: { __typename?: 'Team', id: string, createdAt: string, nameShow: string, shortName?: string | null, shield?: string | null, competition?: { __typename?: 'Competition', id: string, code: string, displayName: string, rank: number } | null } | null }, seller?: { __typename?: 'FantasyLeagueMember', id: string, user: { __typename?: 'UserAccount', id: string, fullName?: string | null } } | null }>, visibleBids: Array<{ __typename?: 'Bid', id: string, createdAt: string, amount: number, status: string, marketEntry: { __typename?: 'MarketEntry', id: string, player: { __typename?: 'Player', id: string, createdAt: string, nick: string, name?: string | null, lastName?: string | null, role?: PlayerRoleEnum | null, marketValue?: number | null, image?: string | null, totalScore?: number | null, lastWeekScore?: number | null, lastWeekNumber?: number | null, team?: { __typename?: 'Team', id: string, createdAt: string, nameShow: string, shortName?: string | null, shield?: string | null, competition?: { __typename?: 'Competition', id: string, code: string, displayName: string, rank: number } | null } | null }, seller?: { __typename?: 'FantasyLeagueMember', id: string, user: { __typename?: 'UserAccount', id: string, fullName?: string | null } } | null }, bidder?: { __typename?: 'FantasyLeagueMember', id: string, user: { __typename?: 'UserAccount', id: string, fullName?: string | null } } | null }> } | null };

export type GetFantasyLeagueMatchWeekScoresQueryVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
  matchWeekId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetFantasyLeagueMatchWeekScoresQuery = { __typename?: 'Query', fantasyLeagueMatchWeekScores?: { __typename?: 'MatchWeekScores', hasPrevious: boolean, hasNext: boolean, previousMatchWeekId?: string | null, nextMatchWeekId?: string | null, lineups: Array<{ __typename?: 'Lineup', id: string, totalScore?: number | null, fantasyLeagueMember: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null, user: { __typename?: 'UserAccount', id: string, picture?: string | null, fullName?: string | null, updatedAt: string } } }>, standings: Array<{ __typename?: 'FantasyLeagueStanding', id: string, position: number, totalScore: number, fantasyLeagueMember: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null, user: { __typename?: 'UserAccount', id: string, picture?: string | null, fullName?: string | null, updatedAt: string } } }>, previousStandings: Array<{ __typename?: 'FantasyLeagueStanding', id: string, position: number, fantasyLeagueMember: { __typename?: 'FantasyLeagueMember', id: string } }>, currentMatchWeek: { __typename?: 'MatchWeek', id: string, weekNumber: number } } | null };

export type PublicFantasyLeagueMemberInfoQueryVariables = Exact<{
  fantasyLeagueMemberId: Scalars['ID']['input'];
}>;


export type PublicFantasyLeagueMemberInfoQuery = { __typename?: 'Query', publicFantasyLeagueMemberInfo?: { __typename?: 'PublicFantasyLeagueMemberInfo', fantasyLeagueMemberId: string, teamName?: string | null, players: Array<{ __typename?: 'Player', id: string, createdAt: string, nick: string, name?: string | null, lastName?: string | null, image?: string | null, role?: PlayerRoleEnum | null, marketValue?: number | null, totalScore?: number | null, lastWeekNumber?: number | null, lastWeekScore?: number | null, team?: { __typename?: 'Team', id: string, createdAt: string, nameShow: string, shield?: string | null, shieldPng?: string | null, shortName?: string | null, competition?: { __typename?: 'Competition', id: string, code: string, displayName: string, rank: number } | null } | null }> } | null };

export type GetFantasyLeagueMemberPlayersQueryVariables = Exact<{
  fantasyLeagueMemberId: Scalars['ID']['input'];
}>;


export type GetFantasyLeagueMemberPlayersQuery = { __typename?: 'Query', fantasyLeagueMemberPlayers?: { __typename?: 'FantasyLeagueMemberPlayers', tactics?: string | null, fantasyTeamPlayers: Array<{ __typename?: 'FantasyTeamPlayer', id: string, createdAt: string, startingPosition: number, individuallyProtected: boolean, weeklyWindowProtected: boolean, releaseClausePayable: boolean, player: { __typename?: 'Player', id: string, createdAt: string, nick: string, name?: string | null, lastName?: string | null, role?: PlayerRoleEnum | null, marketValue?: number | null, image?: string | null, totalScore?: number | null, lastWeekNumber?: number | null, lastWeekScore?: number | null, team?: { __typename?: 'Team', id: string, createdAt: string, nameShow: string, shortName?: string | null, shield?: string | null, competition?: { __typename?: 'Competition', id: string, code: string, displayName: string, rank: number } | null } | null } }> } | null };

export type GetFantasyLeagueMembersQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetFantasyLeagueMembersQuery = { __typename?: 'Query', fantasyLeague?: { __typename?: 'FantasyLeague', id: string, name: string, members: Array<{ __typename?: 'FantasyLeagueMember', id: string, role: string, budget: number, teamName?: string | null, user: { __typename?: 'UserAccount', id: string, fullName?: string | null, picture?: string | null, updatedAt: string }, fantasyTeamPlayers: Array<{ __typename?: 'FantasyTeamPlayer', id: string, createdAt: string, startingPosition: number, releaseClause?: number | null, signedAt?: string | null, individuallyProtected: boolean, weeklyWindowProtected: boolean, releaseClausePayable: boolean, player: { __typename?: 'Player', id: string } }> }> } | null };

export type GetFantasyLeagueTabsShellQueryVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
}>;


export type GetFantasyLeagueTabsShellQuery = { __typename?: 'Query', currentFantasyLeagueMember?: { __typename?: 'FantasyLeagueMember', id: string, role: string, activityLastReadAt?: string | null, messagesLastReadAt?: string | null, unreadEventsCount: number, unreadMessagesCount: number, unreadActivityCount: number } | null, fantasyLeague?: { __typename?: 'FantasyLeague', id: string, competition: { __typename?: 'Competition', id: string } } | null };

export type GetAvailableCompetitionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableCompetitionsQuery = { __typename?: 'Query', getAvailableCompetitions: Array<{ __typename?: 'Competition', id: string, code: string, displayName: string, rank: number, autonomousCommunity?: { __typename?: 'AutonomousCommunity', id: string, name?: string | null, flagUrl?: string | null } | null, officialChannels?: Array<{ __typename?: 'Channel', id: string, name: string, image?: string | null, updatedAt: string }> | null }> };

export type GetMatchQueryVariables = Exact<{
  matchId: Scalars['ID']['input'];
}>;


export type GetMatchQuery = { __typename?: 'Query', getMatch?: { __typename?: 'Match', id: string, matchDate: string, goalsHome: number, goalsAway: number, status: string, statsCalculatedAt?: string | null, homeTeam: { __typename?: 'Team', id: string, nameShow: string, shortName?: string | null, shield?: string | null, shieldPng?: string | null }, awayTeam: { __typename?: 'Team', id: string, nameShow: string, shortName?: string | null, shield?: string | null, shieldPng?: string | null }, matchPlayers: Array<{ __typename?: 'MatchPlayer', id: string, starterPosition: boolean, minutesPlayed: number, goals: number, penaltyGoals: number, ownGoals: number, yellowCards: number, redCard: boolean, teamGoals: number, rivalGoals: number, fantasyScore?: number | null, player: { __typename?: 'Player', id: string, nick: string, image?: string | null, role?: PlayerRoleEnum | null }, team: { __typename?: 'Team', id: string, shortName?: string | null, shield?: string | null, shieldPng?: string | null } }>, events: Array<{ __typename?: 'Event', id: string, eventType: string, minute: number, player: { __typename?: 'Player', id: string, nick: string } }> } | null };

export type GetMatchesQueryVariables = Exact<{
  matchWeekId?: InputMaybe<Scalars['ID']['input']>;
  seasonCompetitionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetMatchesQuery = { __typename?: 'Query', getMatches?: { __typename?: 'MatchWeekMatches', hasPrevious: boolean, hasNext: boolean, previousMatchWeekId?: string | null, nextMatchWeekId?: string | null, seasonCompetitionId: string, matches: Array<{ __typename?: 'Match', id: string, matchDate: string, goalsHome: number, goalsAway: number, status: string, homeTeam: { __typename?: 'Team', id: string, nameShow: string, shortName?: string | null, shield?: string | null, shieldPng?: string | null }, awayTeam: { __typename?: 'Team', id: string, nameShow: string, shortName?: string | null, shield?: string | null, shieldPng?: string | null } }>, standings: Array<{ __typename?: 'LeagueStanding', id: string, position: number, points: number, played: number, goalsFor: number, goalsAgainst: number, team: { __typename?: 'Team', id: string, nameShow: string, shortName?: string | null, shield?: string | null, shieldPng?: string | null } }>, currentMatchWeek: { __typename?: 'MatchWeek', id: string, weekNumber: number, startDate: any, endDate: any } } | null };

export type GetSeasonCompetitionTeamRosterQueryVariables = Exact<{
  seasonCompetitionTeamId: Scalars['ID']['input'];
}>;


export type GetSeasonCompetitionTeamRosterQuery = { __typename?: 'Query', getSeasonCompetitionTeamRoster?: { __typename?: 'SeasonCompetitionTeam', id: string, seasonCompetition: { __typename?: 'SeasonCompetition', active: boolean, season: { __typename?: 'Season', displayName: string }, competition: { __typename?: 'Competition', displayName: string } }, team: { __typename?: 'Team', id: string, nameShow: string, shortName?: string | null, fullName?: string | null, shield?: string | null, shieldBig?: string | null, shieldPng?: string | null }, players: Array<{ __typename?: 'Player', id: string, nick: string, name?: string | null, lastName?: string | null, role?: PlayerRoleEnum | null, marketValue?: number | null, image?: string | null, totalScore?: number | null, lastWeekScore?: number | null, lastWeekNumber?: number | null, team?: { __typename?: 'Team', id: string, nameShow: string, shield?: string | null, shieldPng?: string | null } | null }> } | null };

export type GetSeasonCompetitionTeamsQueryVariables = Exact<{
  seasonCompetitionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSeasonCompetitionTeamsQuery = { __typename?: 'Query', getSeasonCompetitionTeams?: { __typename?: 'SeasonCompetitionTeams', seasonCompetition: { __typename?: 'SeasonCompetition', id: string, season: { __typename?: 'Season', code: string, displayName: string }, competition: { __typename?: 'Competition', code: string, displayName: string } }, teams: Array<{ __typename?: 'SeasonCompetitionTeam', id: string, team: { __typename?: 'Team', id: string, nameShow: string, shortName?: string | null, shield?: string | null, shieldPng?: string | null } }> } | null };

export type GetSeasonCompetitionsQueryVariables = Exact<{
  seasonId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSeasonCompetitionsQuery = { __typename?: 'Query', getSeasonCompetitions: Array<{ __typename?: 'SeasonCompetition', id: string, active: boolean, season: { __typename?: 'Season', id: string, code: string, displayName: string, active: boolean }, competition: { __typename?: 'Competition', id: string, code: string, displayName: string, rank: number, autonomousCommunity?: { __typename?: 'AutonomousCommunity', id: string, name?: string | null, flagUrl?: string | null } | null } }> };

export type GetSeasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSeasonsQuery = { __typename?: 'Query', getSeasons: Array<{ __typename?: 'Season', id: string, code: string, displayName: string, active: boolean }> };

export type GetTeamQueryVariables = Exact<{
  teamId: Scalars['ID']['input'];
}>;


export type GetTeamQuery = { __typename?: 'Query', getTeam?: { __typename?: 'Team', id: string, nameShow: string, shortName?: string | null, fullName?: string | null, shield?: string | null, shieldBig?: string | null, shieldPng?: string | null, players?: Array<{ __typename?: 'Player', id: string, nick: string, name?: string | null, lastName?: string | null, role?: PlayerRoleEnum | null, marketValue?: number | null, image?: string | null, totalScore?: number | null, lastWeekScore?: number | null, lastWeekNumber?: number | null, team?: { __typename?: 'Team', id: string, nameShow: string, shield?: string | null, shieldPng?: string | null } | null }> | null } | null };

export type GetLeagueEventsQueryVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLeagueEventsQuery = { __typename?: 'Query', fantasyLeagueEvents: Array<{ __typename?: 'LeagueEvent', id: string, type: string, createdAt: string, price?: number | null, releaseClause: boolean, fantasyLeagueMember?: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null } | null, player?: { __typename?: 'Player', id: string, nick: string, role?: PlayerRoleEnum | null, team?: { __typename?: 'Team', id: string, nameShow: string, shortName?: string | null, shield?: string | null } | null } | null, fantasyTeamFrom?: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null } | null, fantasyTeamTo?: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null } | null }> };

export type GetLeagueMessagesQueryVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLeagueMessagesQuery = { __typename?: 'Query', leagueMessages: Array<{ __typename?: 'LeagueMessage', id: string, text: string, createdAt: string, user?: { __typename?: 'UserAccount', id: string, fullName?: string | null, picture?: string | null, updatedAt: string } | null }> };

export type GetLegalContentQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLegalContentQuery = { __typename?: 'Query', legalContent: string };

export type GetUpcomingMatchWeekQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUpcomingMatchWeekQuery = { __typename?: 'Query', getUpcomingMatchWeek?: { __typename?: 'MatchWeek', id: string, startDate: any, weekNumber: number } | null };

export type GetMatchWeekTopPlayersQueryVariables = Exact<{
  matchWeekId: Scalars['ID']['input'];
}>;


export type GetMatchWeekTopPlayersQuery = { __typename?: 'Query', matchWeekTopPlayers?: { __typename?: 'MatchWeekTopPlayers', matchWeek: { __typename?: 'MatchWeek', id: string, weekNumber: number }, players: Array<{ __typename?: 'MatchWeekTopPlayer', fantasyScore: number, player: { __typename?: 'Player', id: string, nick: string, name?: string | null, lastName?: string | null, role?: PlayerRoleEnum | null, marketValue?: number | null, image?: string | null, totalScore?: number | null, team?: { __typename?: 'Team', id: string, nameShow: string, shortName?: string | null, shield?: string | null, shieldPng?: string | null } | null } }> } | null };

export type GetMyChannelQueryVariables = Exact<{
  channelId: Scalars['ID']['input'];
}>;


export type GetMyChannelQuery = { __typename?: 'Query', myChannel?: { __typename?: 'Channel', id: string, name: string, description?: string | null, followersCount: number, allowComments: boolean, publishAuthorName: boolean } | null };

export type GetMyChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyChannelsQuery = { __typename?: 'Query', myChannels: Array<{ __typename?: 'Channel', id: string, name: string, followersCount: number }> };

export type GetMyFantasyLeaguesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyFantasyLeaguesQuery = { __typename?: 'Query', userAccount?: { __typename?: 'UserAccount', id: string, fantasyLeagueMembers: Array<{ __typename?: 'FantasyLeagueMember', id: string, unreadEventsCount: number, unreadMessagesCount: number, unreadActivityCount: number, fantasyLeague: { __typename?: 'FantasyLeague', id: string, name: string, isPublic: boolean, participantsCount: number, image?: string | null, updatedAt: string, creator?: { __typename?: 'UserAccount', id: string, fullName?: string | null } | null } }> } | null };

export type GetMyMarketBidsQueryVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
}>;


export type GetMyMarketBidsQuery = { __typename?: 'Query', visibleBids: Array<{ __typename?: 'Bid', id: string, amount: number, marketEntry: { __typename?: 'MarketEntry', id: string }, bidder?: { __typename?: 'FantasyLeagueMember', id: string } | null }> };

export type GetPastBidsQueryVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPastBidsQuery = { __typename?: 'Query', fantasyLeagueMemberPastBids: Array<{ __typename?: 'Bid', id: string, amount: number, status: string, createdAt: string, marketEntry: { __typename?: 'MarketEntry', id: string, seller?: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null } | null, player: { __typename?: 'Player', id: string, createdAt: string, nick: string, name?: string | null, lastName?: string | null, image?: string | null, role?: PlayerRoleEnum | null, totalScore?: number | null, lastWeekNumber?: number | null, lastWeekScore?: number | null, marketValue?: number | null, team?: { __typename?: 'Team', id: string, createdAt: string, nameShow: string, shortName?: string | null, shield?: string | null, competition?: { __typename?: 'Competition', id: string, code: string, displayName: string, rank: number } | null } | null } }, bidder?: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null } | null }> };

export type PastLeagueMemberLineupQueryVariables = Exact<{
  matchWeekId: Scalars['ID']['input'];
  fantasyLeagueMemberId: Scalars['ID']['input'];
}>;


export type PastLeagueMemberLineupQuery = { __typename?: 'Query', pastLeagueMemberLineup?: { __typename?: 'Lineup', id: string, tactics?: string | null, budget?: number | null, totalScore?: number | null, createdAt: string, updatedAt: string, fantasyLeagueMember: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null, user: { __typename?: 'UserAccount', fullName?: string | null, picture?: string | null, updatedAt: string } }, matchWeek: { __typename?: 'MatchWeek', id: string, weekNumber: number }, lineupPlayers: Array<{ __typename?: 'LineupPlayer', id: string, startingPosition: number, createdAt: string, fantasyScore?: number | null, player: { __typename?: 'Player', id: string, createdAt: string, nick: string, name?: string | null, lastName?: string | null, role?: PlayerRoleEnum | null, marketValue?: number | null, image?: string | null, totalScore?: number | null, lastWeekNumber?: number | null, lastWeekScore?: number | null, team?: { __typename?: 'Team', id: string, createdAt: string, nameShow: string, shortName?: string | null, shield?: string | null, competition?: { __typename?: 'Competition', id: string, code: string, displayName: string, rank: number } | null } | null } }> } | null };

export type GetPastTransferOffersQueryVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPastTransferOffersQuery = { __typename?: 'Query', fantasyLeagueMemberPastTransferOffers: Array<{ __typename?: 'TransferOffer', id: string, amount: number, status: string, createdAt: string, releaseClause: boolean, player: { __typename?: 'Player', id: string, createdAt: string, nick: string, name?: string | null, lastName?: string | null, role?: PlayerRoleEnum | null, marketValue?: number | null, image?: string | null, totalScore?: number | null, lastWeekScore?: number | null, lastWeekNumber?: number | null, team?: { __typename?: 'Team', id: string, createdAt: string, nameShow: string, shortName?: string | null, shield?: string | null, competition?: { __typename?: 'Competition', id: string, code: string, displayName: string, rank: number } | null } | null }, bidder: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null }, seller: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null } }> };

export type GetPostQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPostQuery = { __typename?: 'Query', post?: { __typename?: 'Post', status: string, editable: boolean, id: string, text: string, publishedAt: string, editedAt?: string | null, linkUrl?: string | null, linkTitle?: string | null, channel?: { __typename?: 'Channel', id: string, viewerIsOwner: boolean, name: string, image?: string | null, updatedAt: string, publishAuthorName: boolean } | null, photos: Array<{ __typename?: 'PostPhoto', id: string, url: string }>, author?: { __typename?: 'UserAccount', id: string, fullName?: string | null } | null } | null };

export type GetPostForEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPostForEditQuery = { __typename?: 'Query', post?: { __typename?: 'Post', id: string, text: string, status: string, linkUrl?: string | null, linkTitle?: string | null, photos: Array<{ __typename?: 'PostPhoto', id: string, url: string }>, channel?: { __typename?: 'Channel', id: string, viewerIsOwner: boolean } | null } | null };

export type GetPublicUserProfileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPublicUserProfileQuery = { __typename?: 'Query', publicUserProfile?: { __typename?: 'PublicUserProfile', id: string, fullName?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, picture?: string | null, updatedAt: string, careerStatus?: string | null, channels: Array<{ __typename?: 'Channel', id: string, name: string, description?: string | null, viewerIsOwner: boolean, viewerIsFollowing: boolean }>, careerEntries: Array<{ __typename?: 'CareerEntry', id: string, role: CareerRoleEnum, startDate: any, endDate?: any | null, details?: string | null, careerOrganization: { __typename?: 'CareerOrganization', id: string, name: string } }> } | null };

export type GetCareerEntryOverlapsQueryVariables = Exact<{
  careerEntryId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCareerEntryOverlapsQuery = { __typename?: 'Query', careerEntryOverlaps?: { __typename?: 'CareerEntryOverlaps', totalCount: number, offset: number, limit: number, careerOrganization: { __typename?: 'CareerOrganization', id: string, name: string }, matches: Array<{ __typename?: 'CareerEntryOverlap', profile: { __typename?: 'PublicUserProfile', id: string, fullName?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, picture?: string | null, updatedAt: string, careerStatus?: string | null }, careerEntries: Array<{ __typename?: 'CareerEntry', id: string, role: CareerRoleEnum, startDate: any, endDate?: any | null, details?: string | null, careerOrganization: { __typename?: 'CareerOrganization', id: string, name: string } }> }> } | null };

export type SearchChannelsQueryVariables = Exact<{
  term: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchChannelsQuery = { __typename?: 'Query', searchChannels: { __typename?: 'SearchChannelsResult', totalCount: number, offset: number, limit: number, channels: Array<{ __typename?: 'Channel', id: string, name: string, description?: string | null, viewerIsOwner: boolean, viewerIsFollowing: boolean }> } };

export type SearchFantasyLeaguesQueryVariables = Exact<{
  name: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchFantasyLeaguesQuery = { __typename?: 'Query', searchFantasyLeagues: { __typename?: 'SearchFantasyLeaguesResult', totalCount: number, offset: number, limit: number, leagues: Array<{ __typename?: 'FantasyLeague', id: string, name: string, isPublic: boolean, participantsCount: number, image?: string | null, updatedAt: string, creator?: { __typename?: 'UserAccount', id: string, fullName?: string | null, picture?: string | null } | null, competition: { __typename?: 'Competition', id: string, officialChannels?: Array<{ __typename?: 'Channel', id: string, name: string, image?: string | null, updatedAt: string }> | null } }> } };

export type GetSecretCodeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetSecretCodeQuery = { __typename?: 'Query', fantasyLeague?: { __typename?: 'FantasyLeague', id: string, secretCode: string } | null };

export type SearchPublicProfilesQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchPublicProfilesQuery = { __typename?: 'Query', searchPublicProfiles?: { __typename?: 'PublicUserProfilesPage', totalCount: number, offset: number, limit: number, profiles: Array<{ __typename?: 'PublicUserProfile', id: string, fullName?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, picture?: string | null, updatedAt: string, careerStatus?: string | null }> } | null };

export type GetCareerOrganizationDirectoryQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCareerOrganizationDirectoryQuery = { __typename?: 'Query', careerOrganizationDirectory?: { __typename?: 'CareerOrganizationsPage', totalCount: number, offset: number, limit: number, organizations: Array<{ __typename?: 'CareerOrganization', id: string, name: string, image?: string | null }> } | null };

export type GetCareerOrganizationProfilesQueryVariables = Exact<{
  careerOrganizationId: Scalars['ID']['input'];
  period: CareerOrganizationProfilesPeriodEnum;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCareerOrganizationProfilesQuery = { __typename?: 'Query', careerOrganizationProfiles?: { __typename?: 'CareerOrganizationProfiles', totalCount: number, offset: number, limit: number, careerOrganization: { __typename?: 'CareerOrganization', id: string, name: string, image?: string | null }, profiles: Array<{ __typename?: 'PublicUserProfile', id: string, fullName?: string | null, displayName?: string | null, firstName?: string | null, lastName?: string | null, picture?: string | null, updatedAt: string, careerStatus?: string | null }> } | null };

export type GetTeamTabDataQueryVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
}>;


export type GetTeamTabDataQuery = { __typename?: 'Query', currentFantasyLeagueMember?: { __typename?: 'FantasyLeagueMember', id: string, budget: number, teamName?: string | null, tactics?: string | null, fantasyLeague: { __typename?: 'FantasyLeague', id: string, name: string }, fantasyTeamPlayers: Array<{ __typename?: 'FantasyTeamPlayer', id: string, createdAt: string, startingPosition: number, releaseClause?: number | null, signedAt?: string | null, individuallyProtected: boolean, weeklyWindowProtected: boolean, releaseClausePayable: boolean, player: { __typename?: 'Player', id: string, createdAt: string, nick: string, name?: string | null, lastName?: string | null, role?: PlayerRoleEnum | null, marketValue?: number | null, image?: string | null, totalScore?: number | null, lastWeekScore?: number | null, lastWeekNumber?: number | null, team?: { __typename?: 'Team', id: string, createdAt: string, nameShow: string, shortName?: string | null, shield?: string | null, competition?: { __typename?: 'Competition', id: string, code: string, displayName: string, rank: number } | null } | null } }> } | null };

export type GetUserAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserAccountQuery = { __typename?: 'Query', userAccount?: { __typename?: 'UserAccount', id: string, email: string, sub: string, emailVerified?: boolean | null, name?: string | null, picture?: string | null, firstName?: string | null, lastName?: string | null, fullName?: string | null, displayName?: string | null, careerStatus?: string | null, roles: Array<string>, createdAt: string, updatedAt: string } | null };

export type GetVisibleBidsQueryVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
}>;


export type GetVisibleBidsQuery = { __typename?: 'Query', visibleBids: Array<{ __typename?: 'Bid', id: string, createdAt: string, amount: number, status: string, marketEntry: { __typename?: 'MarketEntry', id: string, player: { __typename?: 'Player', id: string, createdAt: string, nick: string, name?: string | null, lastName?: string | null, role?: PlayerRoleEnum | null, marketValue?: number | null, image?: string | null, totalScore?: number | null, lastWeekScore?: number | null, lastWeekNumber?: number | null, team?: { __typename?: 'Team', id: string, createdAt: string, nameShow: string, shortName?: string | null, shield?: string | null, competition?: { __typename?: 'Competition', id: string, code: string, displayName: string, rank: number } | null } | null }, seller?: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null } | null }, bidder?: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null } | null }> };

export type GetVisibleTransferOffersQueryVariables = Exact<{
  fantasyLeagueId: Scalars['ID']['input'];
}>;


export type GetVisibleTransferOffersQuery = { __typename?: 'Query', visibleTransferOffers: Array<{ __typename?: 'TransferOffer', id: string, amount: number, status: string, createdAt: string, player: { __typename?: 'Player', id: string, createdAt: string, nick: string, name?: string | null, lastName?: string | null, role?: PlayerRoleEnum | null, marketValue?: number | null, image?: string | null, totalScore?: number | null, lastWeekScore?: number | null, lastWeekNumber?: number | null, team?: { __typename?: 'Team', id: string, createdAt: string, nameShow: string, shortName?: string | null, shield?: string | null, competition?: { __typename?: 'Competition', id: string, code: string, displayName: string, rank: number } | null } | null }, bidder: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null }, seller: { __typename?: 'FantasyLeagueMember', id: string, teamName?: string | null } }> };
